import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Popper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import {
  buttonWrapper,
  menuItemStyle,
  menuItemStyleContentWidth,
  textfieldText,
} from "../../style/AppointmentStyle";
import TextView from "../UI/TextView/TextView";
import { nurseForm } from "../../utils/constant";
import UseFetchOptions from "../../helper/UseFetchOptions";
import {
  addOptionInAppointForm,
  updateMedicalTest,
  uploadPatientSummaryVoice,
  batchUpsertClinicalData,
} from "../../connections/postApi";
import { getStaticDataList, getClinicalData } from "../../connections/getApi";
import UseFetchGetOrganizationDetails from "../../helper/UseFetchGetOrganizationDetails";
import { useQuery } from "@tanstack/react-query";
import {
  orangeButton,
  primaryBtnTeal,
  selectStyles,
  textfieldTextPrep,
} from "../../style/PatientDetailsStyle";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../utils/toastUtil";
import { updatePatientAppointment } from "../../connections/putApi";
import { deleteExternalLabreportMultiple } from "../../connections/deleteApi";
import UseFetchReferDoctor from "../../helper/UseFetchReferDoctor";
import { xBtn } from "../../style/LapPageStyle";
import CustomModal from "../CustomModal/CustomModal";
import EditNoteIcon from "@mui/icons-material/EditNote";
import Referrer from "../ModalChildren/Referrer";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import UseFetchInvestigationList from "../../helper/UseFetchInvestigationList";
import UseGetQuickCheckReports from "../../helper/UseGetQuickCheckReports";
import { setAppointmentData } from "../../redux/slices/nurseSlice";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import SaveIcon from "@mui/icons-material/Save";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import ContentCutOutlinedIcon from "@mui/icons-material/ContentCutOutlined";

const fieldBase = {
  width: "100%",
  height: "30px",
  border: "1px solid #D0D8DA",
  borderRadius: "6px",
  fontSize: "12px",
  padding: "0 6px",
  backgroundColor: "white",
  color: "#333",
  outline: "none",
  fontFamily: "Lato, sans-serif",
  boxSizing: "border-box",
};

const labelStyle = {
  fontSize: "10px",
  fontWeight: 700,
  color: "#666",
  textTransform: "uppercase",
  marginBottom: "3px",
  display: "block",
};

const allergySelectStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 999999 }),
  control: (base, state) => ({
    ...base,
    minHeight: "30px",
    height: "30px",
    fontSize: "12px",
    borderRadius: "6px",
    borderColor: state.isFocused ? "#0097B2" : "#D0D8DA",
    boxShadow: state.isFocused ? "0 0 0 1px #0097B2" : "none",
    "&:hover": { borderColor: "#0097B2" },
    fontFamily: "Lato, sans-serif",
    backgroundColor: "white",
    cursor: "pointer",
  }),
  valueContainer: (base) => ({ ...base, padding: "0 6px", height: "30px" }),
  input: (base) => ({ ...base, margin: 0, padding: 0, fontSize: "12px" }),
  indicatorsContainer: (base) => ({ ...base, height: "30px" }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "0 4px",
    color: "#0097B2",
  }),
  clearIndicator: (base) => ({ ...base, padding: "0 4px" }),
  singleValue: (base) => ({ ...base, fontSize: "12px", color: "#333" }),
  placeholder: (base) => ({ ...base, fontSize: "12px", color: "#999" }),
  menu: (base) => ({
    ...base,
    fontSize: "12px",
    zIndex: 9999,
    fontFamily: "Lato, sans-serif",
  }),
  option: (base, state) => ({
    ...base,
    fontSize: "12px",
    padding: "7px 10px",
    cursor: "pointer",
    backgroundColor: state.isSelected
      ? "#0097B2"
      : state.isFocused
        ? "#e6f7fa"
        : "#fff",
    color: state.isSelected ? "#fff" : "#333",
  }),
};

const ALLERGY_AGENT_OPTIONS = [
  "Aceclofenac",
  "Acetaaminophen",
  "Acotiamide",
  "Allopathic",
  "Allopurinol",
  "Amitryptyline",
  "Amlodipine",
  "Amoxycillin",
  "Ampicillin",
  "Analgin",
  "Anticonvulsants",
  "Apremilast",
  "Artemether and Lumefantrine",
  "Aspirin",
  "Atarax",
  "Augmentin",
  "Azathioprine",
  "Azithromycin",
  "B complex",
  "Cetirizine",
  "Ciprofloxacin",
  "Clopidogrel",
  "Co-amoxiclav",
  "Codeine",
  "Dexamethasone",
  "Diclofenac",
  "Doxycycline",
  "Erythromycin",
  "Fluconazole",
  "Ibuprofen",
  "Insulin",
  "Levofloxacin",
  "Metformin",
  "Methotrexate",
  "Metronidazole",
  "Morphine",
  "Naproxen",
  "Nitrofurantoin",
  "Omeprazole",
  "Paracetamol",
  "Penicillin",
  "Prednisolone",
  "Ranitidine",
  "Rifampicin",
  "Salbutamol",
  "Sulfonamides",
  "Tetracycline",
  "Tramadol",
  "Warfarin",
].map((a) => ({ label: a, value: a }));

const ALLERGY_REACTION_OPTIONS = [
  "Abdominal bloating",
  "Abdominal bloating, vomiting",
  "Abdominal bloating/Nausea",
  "Abdominal burning and uneasiness feels",
  "Abdominal dicomfort,Acidity,Nausea",
  "Anaphylaxis",
  "Diarrhoea",
  "Dizziness",
  "Edema",
  "Hives",
  "Itching",
  "Nausea",
  "Rash",
  "Shortness of breath",
  "Skin rash",
  "Swelling",
  "Urticaria",
  "Vomiting",
].map((r) => ({ label: r, value: r }));

const ALLERGY_SEVERITY_OPTIONS = [
  "Mild",
  "Mild to moderate",
  "Moderate",
  "Moderate to severe",
  "Severe",
  "Fatal",
  "Life threatening",
].map((s) => ({ label: s, value: s }));

const ALLERGY_TYPE_OPTIONS = [
  { label: "Medication", value: "Medication" },

  { label: "Other", value: "Other" },
];

const emptySurgicalRow = () => ({
  procedure: "",
  body_site: "",
  findings: "",
  date: "",
  fromChip: false,
});

const emptyAllergyRow = () => ({
  type: ALLERGY_TYPE_OPTIONS[0],
  agent: null,
  reactions: null,
  severity: null,
  startDate: "",
  comments: "",
});

const AllergyRow = ({ data, onChange, disabled = false }) => {
  const set = (field) => (val) => onChange({ ...data, [field]: val });
  return (
    <Box
      sx={{
        border: "1px solid #E1E1E1",
        borderRadius: "8px",
        p: 1,
        mb: 1,
        backgroundColor: disabled ? "#f5f5f5" : "#fafcfc",
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? "none" : "auto",
      }}
    >
      {/* Row 1: Type of Allergy | Agent | Start Date */}
      <Box
        sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1, mb: 1 }}
      >
        <Box>
          <span style={labelStyle}>Type of Allergy</span>
          <Select
            options={ALLERGY_TYPE_OPTIONS}
            value={data.type}
            onChange={set("type")}
            styles={allergySelectStyles}
            menuPortalTarget={document.body}
            isSearchable={false}
          />
        </Box>
        <Box>
          <span style={labelStyle}>Agent</span>
          <Select
            options={ALLERGY_AGENT_OPTIONS}
            value={data.agent}
            onChange={set("agent")}
            placeholder="Select..."
            styles={allergySelectStyles}
            menuPortalTarget={document.body}
            isClearable
          />
        </Box>
      </Box>
      <Box sx={{ mb: 1 }}>
        <span style={labelStyle}>Reactions</span>
        <Select
          options={ALLERGY_REACTION_OPTIONS}
          value={data.reactions}
          onChange={set("reactions")}
          placeholder="Select..."
          styles={allergySelectStyles}
          menuPortalTarget={document.body}
          isClearable
        />
      </Box>
      <Box
        sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1, mb: 1 }}
      >
        <Box>
          <span style={labelStyle}>Start Date</span>
          <input
            type="date"
            style={fieldBase}
            value={data.startDate}
            onChange={(e) => set("startDate")(e.target.value)}
          />
        </Box>
        <Box>
          <span style={labelStyle}>Severity</span>
          <Select
            options={ALLERGY_SEVERITY_OPTIONS}
            value={data.severity}
            onChange={set("severity")}
            placeholder="Select..."
            styles={allergySelectStyles}
            menuPortalTarget={document.body}
            isClearable
          />
        </Box>
      </Box>

      {/* Comments */}
      <Box>
        <span style={labelStyle}>Comments</span>
        <TextField
          fullWidth
          multiline
          minRows={2}
          size="small"
          placeholder="Add comments..."
          value={data.comments}
          onChange={(e) => set("comments")(e.target.value)}
          sx={{
            "& .MuiOutlinedInput-root": {
              fontSize: "12px",
              fontFamily: "Lato, sans-serif",
              borderRadius: "6px",
              backgroundColor: "white",
              "& fieldset": { borderColor: "#D0D8DA" },
              "&:hover fieldset": { borderColor: "#0097B2" },
              "&.Mui-focused fieldset": { borderColor: "#0097B2" },
            },
            "& .MuiOutlinedInput-input": {
              padding: "4px 6px",
              fontSize: "12px",
            },
          }}
        />
      </Box>
    </Box>
  );
};

const PatientReport = () => {
  const [allFormFields, setAllFormFields] = useState(nurseForm);
  const [formState, setFormState] = useState({});
  const [expandedGeneral, setExpandedGeneral] = useState(true);
  const [expandedInvestigations, setExpandedInvestigations] = useState(false);
  const [expandedChiefComplaint, setExpandedChiefComplaint] = useState(false);
  const [chiefComplaintForm, setChiefComplaintForm] = useState({
    complaint: null,
    duration: "",
    comments: "",
  });
  const [expandedAllergies, setExpandedAllergies] = useState(false);
  const [nkda, setNkda] = useState(false);
  const [allergyNotes, setAllergyNotes] = useState("");
  const [allergyExtraRows, setAllergyExtraRows] = useState(0);
  const [allergyRows, setAllergyRows] = useState([
    emptyAllergyRow(),
    emptyAllergyRow(),
    emptyAllergyRow(),
  ]);
  const updateAllergyRow = (i, data) =>
    setAllergyRows((p) => p.map((r, idx) => (idx === i ? data : r)));
  const addAllergyRow = () => setAllergyRows((p) => [...p, emptyAllergyRow()]);
  const [expandedPastMedical, setExpandedPastMedical] = useState(false);
  const [noPastMedical, setNoPastMedical] = useState(false);
  const [pastMedicalSelected, setPastMedicalSelected] = useState([]);
  const [pastMedicalComments, setPastMedicalComments] = useState("");
  const [expandedPastSurgical, setExpandedPastSurgical] = useState(false);
  const [noPastSurgical, setNoPastSurgical] = useState(false);
  const [showMoreSurgeries, setShowMoreSurgeries] = useState(false);
  const [surgicalRows, setSurgicalRows] = useState(
    Array.from({ length: 5 }, emptySurgicalRow),
  );
  const [surgicalMoreRows, setSurgicalMoreRows] = useState(
    Array.from({ length: 10 }, emptySurgicalRow),
  );
  const updateSurgicalRow = (i, field, val) =>
    setSurgicalRows((p) =>
      p.map((r, idx) => (idx === i ? { ...r, [field]: val } : r)),
    );
  const updateSurgicalMoreRow = (i, field, val) =>
    setSurgicalMoreRows((p) =>
      p.map((r, idx) => (idx === i ? { ...r, [field]: val } : r)),
    );
  const [expandedGynHistory, setExpandedGynHistory] = useState(false);
  const [gynLmpRadio, setGynLmpRadio] = useState("lmp"); // "lmp" | "hysterectomy" | "menopause"
  const [gynLmp, setGynLmp] = useState("");
  const [gynHysterectomy, setGynHysterectomy] = useState("");
  const [gynMenopause, setGynMenopause] = useState("");
  const [gynAbnormalPap, setGynAbnormalPap] = useState("");
  const [gynTotalPregnancies, setGynTotalPregnancies] = useState("");
  const [gynTreatment, setGynTreatment] = useState("");
  const [gynMenarche, setGynMenarche] = useState("");
  const [gynCycle, setGynCycle] = useState("");
  const [gynCycleDuration, setGynCycleDuration] = useState("");
  const [gynFlow, setGynFlow] = useState("");
  const [gynCramps, setGynCramps] = useState("");
  const [gynMenstrualProblems, setGynMenstrualProblems] = useState("");
  const [gynBirthControl, setGynBirthControl] = useState({
    none: false,
    pills: false,
    condoms: false,
    btl: false,
    contraceptiveRing: false,
    vasectomy: false,
    implanon: false,
    attemptingPregnancy: false,
    iud: false,
    others: false,
  });
  const [gynPillsText, setGynPillsText] = useState("");
  const [gynBtlText, setGynBtlText] = useState("");
  const [gynVasectomyText, setGynVasectomyText] = useState("");
  const [gynImplanonText, setGynImplanonText] = useState("");
  const [gynIudType, setGynIudType] = useState("");
  const [gynIudInsertDate, setGynIudInsertDate] = useState("");
  const [gynIudRemovalDate, setGynIudRemovalDate] = useState("");
  const [gynOthersText, setGynOthersText] = useState("");

  const [expandedPastPregnancies, setExpandedPastPregnancies] = useState(false);
  const [pregnancyMoreRows, setPregnancyMoreRows] = useState(0);
  const emptyPregnancyRow = () => ({
    date: "",
    ga_weeks: "",
    birth_weight: "",
    type_of_delivery: "",
    place_of_delivery: "",
    preterm_labor: "",
    outcome: "",
    comments: "",
  });
  const [pregnancyRows, setPregnancyRows] = useState(
    Array.from({ length: 10 }, emptyPregnancyRow),
  );
  const updatePregnancyRow = (i, field, val) =>
    setPregnancyRows((p) =>
      p.map((r, idx) => (idx === i ? { ...r, [field]: val } : r)),
    );
  const [expandedFamilyHistory, setExpandedFamilyHistory] = useState(false);
  const [noFamilyIllness, setNoFamilyIllness] = useState(false);
  const [familyExtraCols, setFamilyExtraCols] = useState([]); // max 2, each {relation, age, livingStatus, checked:{}, extraInputs:{}}
  const [familyComments, setFamilyComments] = useState("");

  const FAMILY_RELATION_OPTIONS = [
    "Aunt",
    "Brother",
    "Daughter",
    "Elder Brother",
    "Elder Sister",
    "Grand Father",
    "Grand Mother",
    "Maternal Aunt",
    "Maternal Cousin",
    "Maternal Grandfather",
    "Maternal Grandmother",
    "Maternal Uncle",
    "Paternal Aunt",
    "Paternal Cousin",
    "Paternal Grandfather",
    "Paternal Grandmother",
    "Paternal Uncle",
    "Sister",
    "Son",
    "Spouse",
    "Younger Brother",
    "Younger Sister",
  ];
  const FAMILY_DISEASES = [
    "Arthritis / CTD",
    "Abdominal Kochs",
    "Acid Peptic disease",
    "Anaemia",
    "APS (Antiphospholid Antibody Syndrome)",
    "Bronchial Asthma",
    "Cancer",
    "Carpal Tunnel Syndrome",
    "Diabetes Mellitus",
    "Dyslipidemia",
    "Fibromyalgia",
    "Interstitial lung Disease (ILD)",
    "OA Knees",
    "Obstructive sleep Apnoea",
    "Oro -mandibular Dyskinesia",
    "Osteoporosis",
    "Pulmonary Arterial Hypertension",
    "Rheumatoid Arthritis",
    "Secondary Sjogrens syndrome",
    "Sjogrens Syndrome",
    "Systemic Lupus Erythematosus",
    "Systemic Sclerosis",
    "Skin Disease",
    "Takayasus Aortoarteritis",
    "Thyroid",
    "Upper Respiratory Tract Infection",
    "Urinary Tract Infection",
    "Hypertension",
    "IHD(Ischemic Heart Disease)",
    "TB Meningitis",
    "Psychiatric disturbances",
    "History of TB",
    "Malignancy",
  ];

  const familyStaticCols = [
    { key: "father", label: "Father" },
    { key: "mother", label: "Mother" },
  ];
  const [familyStaticData, setFamilyStaticData] = useState({
    father: { age: "", livingStatus: "", checked: {}, extraInput: "" },
    mother: { age: "", livingStatus: "", checked: {}, extraInput: "" },
  });
  // 2 default select cols (pre-existing, not added via More)
  const [familyDefaultSelectCols, setFamilyDefaultSelectCols] = useState([
    { relation: "", age: "", livingStatus: "", checked: {}, extraInput: "" },
    { relation: "", age: "", livingStatus: "", checked: {}, extraInput: "" },
  ]);
  const updateDefaultSelectCol = (i, field, value) =>
    setFamilyDefaultSelectCols((p) =>
      p.map((c, idx) => (idx === i ? { ...c, [field]: value } : c)),
    );
  const toggleDefaultSelectDisease = (i, disease) =>
    setFamilyDefaultSelectCols((p) =>
      p.map((c, idx) =>
        idx === i
          ? { ...c, checked: { ...c.checked, [disease]: !c.checked[disease] } }
          : c,
      ),
    );

  const updateStaticCol = (key, field, value) =>
    setFamilyStaticData((p) => ({
      ...p,
      [key]: { ...p[key], [field]: value },
    }));
  const toggleStaticDisease = (key, disease) =>
    setFamilyStaticData((p) => ({
      ...p,
      [key]: {
        ...p[key],
        checked: { ...p[key].checked, [disease]: !p[key].checked[disease] },
      },
    }));

  const addFamilyCol = () => {
    if (familyExtraCols.length >= 2) return;
    setFamilyExtraCols((p) => [
      ...p,
      { relation: "", age: "", livingStatus: "", checked: {}, extraInputs: {} },
    ]);
  };
  const removeFamilyCol = () => setFamilyExtraCols((p) => p.slice(0, -1));
  const updateExtraCol = (i, field, value) =>
    setFamilyExtraCols((p) =>
      p.map((c, idx) => (idx === i ? { ...c, [field]: value } : c)),
    );
  const toggleExtraDisease = (i, disease) =>
    setFamilyExtraCols((p) =>
      p.map((c, idx) =>
        idx === i
          ? { ...c, checked: { ...c.checked, [disease]: !c.checked[disease] } }
          : c,
      ),
    );
  const updateExtraColDiseaseInput = (i, disease, val) =>
    setFamilyExtraCols((p) =>
      p.map((c, idx) =>
        idx === i
          ? { ...c, extraInputs: { ...c.extraInputs, [disease]: val } }
          : c,
      ),
    );
  const [expandedSocialHistory, setExpandedSocialHistory] = useState(false);
  const [socialMaritalStatus, setSocialMaritalStatus] = useState("");
  const [socialEducation, setSocialEducation] = useState("");
  const [socialOccupation, setSocialOccupation] = useState("");
  const [socialIndustry, setSocialIndustry] = useState("");
  const [socialStress, setSocialStress] = useState("");
  const [socialDiet, setSocialDiet] = useState("");
  const [socialCaffeineIntake, setSocialCaffeineIntake] = useState("");
  const [socialTobaccoSmoking, setSocialTobaccoSmoking] = useState("");
  const [socialTobaccoSmokingQty, setSocialTobaccoSmokingQty] = useState("");
  const [socialTobaccoSmokingDuration, setSocialTobaccoSmokingDuration] =
    useState("");
  const [socialTobaccoChewing, setSocialTobaccoChewing] = useState("");
  const [socialTobaccoChewingQty, setSocialTobaccoChewingQty] = useState("");
  const [socialTobaccoChewingDuration, setSocialTobaccoChewingDuration] =
    useState("");
  const [socialAlcohol, setSocialAlcohol] = useState("");
  const [socialAlcoholIfYes, setSocialAlcoholIfYes] = useState("");
  const [socialAlcoholDuration, setSocialAlcoholDuration] = useState("");
  const [socialDrugs, setSocialDrugs] = useState("");
  const [socialDrugsSelected, setSocialDrugsSelected] = useState([]);
  const [socialDrugsDuration, setSocialDrugsDuration] = useState("");
  const [socialExercise, setSocialExercise] = useState("");
  const [socialComments, setSocialComments] = useState("");

  const DRUG_OPTIONS = [
    "Marijuana",
    "Cocaine",
    "Heroin",
    "Methamphetamine",
    "Ecstasy",
    "LSD",
    "Opioids",
    "Other",
  ];
  const TOBACCO_SMOKING_QTY = ["< 1 ppd", "1 ppd", "1-2 ppd", "> 2 ppd"];
  const TOBACCO_CHEWING_QTY = ["1/day", "2-4/day", "5-10/day", "> 10/day"];

  const [expandedPastDiagnostic, setExpandedPastDiagnostic] = useState(false);
  const [noPastDiagnostic, setNoPastDiagnostic] = useState(false); // false | "no_past_diagnostic_history"
  const [showMoreDiagnostic, setShowMoreDiagnostic] = useState(false);
  const emptyDiagnosticRow = () => ({
    procedure: "",
    body_site: "",
    findings: "",
    date: "",
    fromChip: false,
  });
  const [diagnosticRows, setDiagnosticRows] = useState(
    Array.from({ length: 5 }, emptyDiagnosticRow),
  );
  const [diagnosticMoreRows, setDiagnosticMoreRows] = useState(
    Array.from({ length: 10 }, emptyDiagnosticRow),
  );
  const updateDiagnosticRow = (i, field, val) =>
    setDiagnosticRows((p) =>
      p.map((r, idx) => (idx === i ? { ...r, [field]: val } : r)),
    );
  const updateDiagnosticMoreRow = (i, field, val) =>
    setDiagnosticMoreRows((p) =>
      p.map((r, idx) => (idx === i ? { ...r, [field]: val } : r)),
    );

  const PAST_DIAGNOSTIC_CONDITIONS = [
    "Abdominal U/S",
    "Arterial U/S",
    "Bladder U/S",
    "Bone Density",
    "Breast Bx",
    "Breast U/S",
    "Carotid U/S",
    "Chest Xray",
    "EKG",
    "Echocardiogram",
    "Kidney U/S",
    "MRI Cervical Spine",
    "MRI LS Spine",
    "Mammogram",
    "Optometry (Eye Exam)",
    "Papsmear",
    "Pelvic U/S",
    "Prostate U/S",
    "Sleep Study",
    "Spirometry",
    "Thyroid U/S",
    "Venous U/S",
  ];

  const addDiagnosticProcedureFromChip = (procedure) => {
    setDiagnosticRows((prev) => {
      const existingIdx = prev.findIndex(
        (r) => r.fromChip && r.procedure === procedure,
      );
      if (existingIdx !== -1)
        return prev.map((r, i) =>
          i === existingIdx ? { ...r, procedure: "", fromChip: false } : r,
        );
      const emptyIdx = prev.findIndex((r) => !r.procedure);
      if (emptyIdx !== -1)
        return prev.map((r, i) =>
          i === emptyIdx ? { ...r, procedure, fromChip: true } : r,
        );
      return [
        ...prev,
        { procedure, body_site: "", findings: "", date: "", fromChip: true },
      ];
    });
  };

  const PAST_SURGICAL_CONDITIONS = [
    "Appendectomy",
    "Arterial Repair",
    "C-section",
    "CABG",
    "Cardiac Surgery",
    "Cataract Surgery",
    "Gall Bladder Removal",
    "Hernia Repair",
    "Hysterectomy",
    "Nephrectomy",
    "Prostate Surgery",
    "Tubal ligation",
    "Valve Replacement",
  ];

  const PAST_MEDICAL_CONDITIONS = [
    "APS (Antiphospholid Antibody Syndrome)",
    "AVN Femur",
    "Abdominal Kochs",
    "Acid Peptic disease",
    "Anaemia",
    "Arthritis / CTD",
    "Carpal Tunnel Syndrome",
    "Central Nervous System",
    "Diabetes Mellitus",
    "Dyslipidemia",
    "Emphysema",
    "Epilepsy (seizures)",
    "Fibromyalgia",
    "Gastrointestinal Disorder",
    "Goiter",
    "Haematological Disorder",
    "History of Blood Transfusion",
    "History of TB",
    "Hypertension",
    "Hyperthyroidism",
    "Hypothyrodism",
    "IHD(Ischemic Heart Disease)",
    "Interstitial lung Disease (ILD)",
    "Kidney Ailment",
    "Liver Disease",
    "Lung Disorder",
    "Malignancy",
    "Migraine",
    "OA Knees",
    "Obstructive sleep Apnoea",
    "Oro -mandibular Dyskinesia",
    "Osteoporosis",
    "Psychiatric disturbances",
    "Pulmonary Arterial Hypertension",
    "Rheumatic Heart Disease",
    "Rheumatoid Arthritis",
    "Secondary Sjogrens syndrome",
    "Sjogrens Syndrome",
    "Skin Disease",
    "Sleep",
    "Systemic Lupus Erythematosus",
    "Systemic Sclerosis",
    "Takayasus Aortoarteritis",
    "Thyroid",
    "Ulcerative Colitis",
    "Upper Respiratory Tract Infection",
    "Urinary Tract Infection",
    "kidney disease",
  ];

  const togglePastMedical = (condition) => {
    setPastMedicalSelected((prev) =>
      prev.includes(condition)
        ? prev.filter((c) => c !== condition)
        : [...prev, condition],
    );
  };

  const [newValues, setNewValues] = useState({});
  const [showNewValueField, setShowNewValueField] = useState({});
  const [fieldOptions, setFieldOptions] = useState({});
  const [openSearchDropDown, setOpenSearchDropDown] = useState(false);
  const [patientId, setPatientId] = useState(null);
  const [resetSlot, setResetSlot] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [newSlotOption, setNewSlotOption] = useState({});
  const [errors, setErrors] = useState({});
  const [drConsultId, setDrConsultId] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [duplicateDialog, setDuplicateDialog] = useState({ open: false, duplicates: [], dedupedArr: [] });

  const {
    nurse: { patientData, patientDetailsData, appointmentData, isLoading },
  } = useSelector((state) => state);
  // hooks to get data
  //  console.log(appointmentData)

  const dispatch = useDispatch();
  const { data: featureOrgBase } = UseFetchGetOrganizationDetails();
  const isClinicalDataEnabled =
    featureOrgBase?.payload?.organization_features?.some(
      (f) => f?.key === "clinical_datum" && f?.active === true,
    );
  // Fetch all clinical data keys at once and pre-fill all accordion forms
  useEffect(() => {
    if (!patientDetailsData?.id || !appointmentData?.id) return;
    const keys = [
      "chief_complaints",
      "allergies",
      "past_medical_hx",
      "past_surgical_hx",
      "past_diagnostic_hx",
      "gyn_hx",
      "past_pregnancies_hx",
      "family_history",
      "social_hx",
    ];
    getClinicalData(patientDetailsData.id, appointmentData.id, keys).then(
      (res) => {
        const records = res?.payload?.clinical_data || [];
        const byKey = {};
        records.forEach((r) => {
          byKey[r.name] = r?.value;
        });

        // Chief Complaints
        const cc = byKey["chief_complaints"];
        if (cc) {
          setChiefComplaintForm({
            complaint: cc.complaint
              ? Array.isArray(cc.complaint)
                ? cc.complaint.map((c) => ({
                    label: c.trim(),
                    value: c.trim(),
                  }))
                : cc.complaint
                    .split(",")
                    .map((c) => ({ label: c.trim(), value: c.trim() }))
                    .filter((c) => c.value)
              : null,
            duration: cc.duration || "",
            comments: cc.comments || "",
          });
        }

        // Allergies
        const al = byKey["allergies"];
        if (al) {
          setNkda(al.nkda || false);
          setAllergyNotes(typeof al.nkda === "string" ? al.nkda : "");
          if (al.items?.length)
            setAllergyRows(
              al.items
                .filter((e) => e.agent)
                .map((e) => ({
                  type: e.type_of_allergy
                    ? { label: e.type_of_allergy, value: e.type_of_allergy }
                    : { label: "Medication", value: "Medication" },
                  agent: e.agent ? { label: e.agent, value: e.agent } : null,
                  reactions: e.reactions
                    ? { label: e.reactions, value: e.reactions }
                    : null,
                  severity: e.severity
                    ? { label: e.severity, value: e.severity }
                    : null,
                  startDate: e.start_date || "",
                  comments: e.comments || "",
                })),
            );
        }

        // Past Medical
        const pm = byKey["past_medical_hx"];
        if (pm) {
          setNoPastMedical(
            pm.no_past_medical_hx === "1" ? "no_past_medical_history" : false,
          );
          setPastMedicalSelected(
            pm.diseases
              ? pm.diseases
                  .split(",")
                  .map((c) => c.trim())
                  .filter(Boolean)
              : [],
          );
          setPastMedicalComments(pm.comments || "");
        }

        // Past Surgical
        const ps = byKey["past_surgical_hx"];
        if (ps) {
          setNoPastSurgical(
            ps.no_past_surgical_hx === "1" ? "no_past_surgical_history" : false,
          );
          if (ps.items?.length)
            setSurgicalRows((p) =>
              ps.items
                .slice(0, 5)
                .map((r) => ({
                  procedure: r.procedure || "",
                  body_site: r.body_site || "",
                  findings: r.findings || "",
                  date: r.procedure_date || "",
                }))
                .concat(p.slice(ps.items.slice(0, 5).length)),
            );
        }

        // Past Diagnostic
        const pd = byKey["past_diagnostic_hx"];
        if (pd) {
          setNoPastDiagnostic(
            pd.no_past_diagnostic_hx === "1"
              ? "no_past_diagnostic_history"
              : false,
          );
          if (pd.items?.length)
            setDiagnosticRows((p) =>
              pd.items
                .slice(0, 5)
                .map((r) => ({
                  procedure: r.procedure || "",
                  body_site: r.body_site || "",
                  findings: r.findings || "",
                  date: r.procedure_date || "",
                  fromChip: false,
                }))
                .concat(p.slice(pd.items.slice(0, 5).length)),
            );
        }

        // Gyn History
        const gh = byKey["gyn_hx"];
        if (gh) {
          if (gh.lmp) {
            setGynLmpRadio("lmp");
            setGynLmp(gh.lmp);
          } else if (gh.hysterectomy) {
            setGynLmpRadio("hysterectomy");
            setGynHysterectomy(gh.hysterectomy);
          } else if (gh.menopause) {
            setGynLmpRadio("menopause");
            setGynMenopause(gh.menopause);
          }
          setGynAbnormalPap(gh.abnormal_pap || "");
          setGynTotalPregnancies(gh.total_pregnancies || "");
          setGynTreatment(gh.treatment || "");
          if (gh.menstrual_history) {
            setGynMenarche(gh.menstrual_history.menarche || "");
            setGynCycle(gh.menstrual_history.cycle || "");
            setGynCycleDuration(gh.menstrual_history.cycle_duration || "");
            setGynFlow(gh.menstrual_history.flow || "");
            setGynCramps(gh.menstrual_history.cramps || "");
            setGynMenstrualProblems(
              gh.menstrual_history.menstrual_problems || "",
            );
          }
          if (gh.birth_control) {
            const bc = gh.birth_control;
            setGynBirthControl({
              none: bc.none || false,
              pills: !!bc.pills,
              condoms: bc.condoms || false,
              btl: !!bc.btl,
              contraceptiveRing: bc.contraceptive_ring || false,
              vasectomy: !!bc.vasectomy,
              implanon: !!bc.implanon,
              attemptingPregnancy: bc.attempting_pregnancy || false,
              iud: !!bc.iud,
              others: !!bc.others,
            });
            if (bc.pills && typeof bc.pills === "string")
              setGynPillsText(bc.pills);
            if (bc.btl && typeof bc.btl === "string") setGynBtlText(bc.btl);
            if (bc.vasectomy && typeof bc.vasectomy === "string")
              setGynVasectomyText(bc.vasectomy);
            if (bc.implanon && typeof bc.implanon === "string")
              setGynImplanonText(bc.implanon);
            if (bc.iud && typeof bc.iud === "string") setGynIudType(bc.iud);
            setGynIudInsertDate(bc["Insert Date"] || "");
            setGynIudRemovalDate(bc["Removal Date"] || "");
            if (bc.others && typeof bc.others === "string")
              setGynOthersText(bc.others);
          }
        }

        // Past Pregnancies
        const pp = byKey["past_pregnancies_hx"];
        if (pp?.items?.length)
          setPregnancyRows((p) =>
            pp.items.slice(0, 10).concat(p.slice(pp.items.slice(0, 10).length)),
          );

        // Family History
        const fh = byKey["family_history"];
        if (fh) {
          setNoFamilyIllness(fh.no_family_illness || false);
          if (fh.father)
            setFamilyStaticData((p) => ({
              ...p,
              father: {
                age: fh.father.age || "",
                livingStatus: fh.father.living_status || "",
                checked: Object.fromEntries(
                  (fh.father.diseases || []).map((x) => [x, true]),
                ),
                extraInput: "",
              },
            }));
          if (fh.mother)
            setFamilyStaticData((p) => ({
              ...p,
              mother: {
                age: fh.mother.age || "",
                livingStatus: fh.mother.living_status || "",
                checked: Object.fromEntries(
                  (fh.mother.diseases || []).map((x) => [x, true]),
                ),
                extraInput: "",
              },
            }));
          if (fh.members?.length)
            setFamilyDefaultSelectCols((p) =>
              fh.members
                .slice(0, 2)
                .map((m, i) => ({
                  relation: m.relation || "",
                  age: m.age || "",
                  livingStatus: m.living_status || "",
                  checked: Object.fromEntries(
                    (m.diseases || []).map((x) => [x, true]),
                  ),
                  extraInput: p[i]?.extraInput || "",
                  extraInputs: m.malignancy ? { Malignancy: m.malignancy } : {},
                }))
                .concat(p.slice(fh.members.slice(0, 2).length)),
            );
          setFamilyComments(fh.comments || "");
        }

        // Social History
        const sh = byKey["social_hx"];
        if (sh) {
          setSocialMaritalStatus(sh.maritalstatus || "");
          setSocialOccupation(sh.occupation || "");
          setSocialIndustry(sh.industry || "");
          setSocialStress(sh.generalstresslevel || "");
          setSocialDiet(sh.diet || "");
          setSocialCaffeineIntake(sh.caffeineintake || "");
          setSocialTobaccoSmoking(sh.tobacco_status || "");
          setSocialTobaccoSmokingQty(sh.tobacco_quan || "");
          setSocialTobaccoSmokingDuration(sh.tobacco_quit_duration || "");
          setSocialTobaccoChewing(sh.chewing_status || "");
          setSocialTobaccoChewingQty(sh.chewing_quan || "");
          setSocialTobaccoChewingDuration(sh.chewing_quit_duration || "");
          setSocialAlcohol(sh.alcohol || "");
          setSocialAlcoholIfYes(sh.alcohol_yes || "");
          setSocialAlcoholDuration(sh.alcohol_quit_duration || "");
          setSocialDrugs(sh.drugs || "");
          setSocialDrugsSelected(
            sh.drugs_yes
              ? sh.drugs_yes
                  .split(",")
                  .map((s) => s.trim())
                  .filter(Boolean)
              : [],
          );
          setSocialDrugsDuration(sh.drugs_quit_duration || "");
          setSocialExercise(sh.excercise || "");
          setSocialComments(sh.comments || "");
        }
      },
    );
  }, [patientDetailsData?.id, appointmentData?.id]);

  const { data: allOccupation, refetch: refetchOccupation } =
    UseFetchOptions("occupations");
  const { data: allCities, refetch: refetchCities } = UseFetchOptions("cities");
  const { data: allEducations, refetch: refetchEducation } =
    UseFetchOptions("educations");
  const { data: chiefComplaintsData } = useQuery({
    queryKey: ["staticDataList", "chief_complaints"],
    queryFn: () => getStaticDataList("chief_complaints"),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
  });
  const complaintOptions = (
    chiefComplaintsData?.payload?.data?.complaints || []
  ).map((c) => ({
    label: c,
    value: c,
  }));
  const { data: investigationList, isLoading: isLoadingInvestigation } =
    UseFetchInvestigationList(drConsultId);

  // const { data: patientDetailsQuery } = UsePatientDetail(patientId);
  // // const { data: patientAppointmentQuery } = UseFetchAppointmentDetailsPatient(
  // //   patientDetailsQuery?.payload?.appointments[0]?.id
  // // );

  const dates =
    patientDetailsData?.appointments?.filter((appointment) =>
      ["completed", "paid"].includes(appointment.status),
    ) || [];

  // console.log(dates, 'dates')

  const { data: quickCheckTestReports } = UseGetQuickCheckReports(
    patientDetailsData?.id,
    patientDetailsData?.appointments && dates[0]?.id,
  );

  const { data: referDr, refetch: refetchReferrer } = UseFetchReferDoctor();
  // Initialize fieldOptions with the initial options from appointmentForm

  // set education occupation and cities option in fields
  useEffect(() => {
    const newReferDr = referDr?.payload?.referrers?.map((refer) => ({
      id: refer?.id,
      title: `${refer?.full_name || ""}${
        refer?.profession ? ` [${refer?.profession}]` : ""
      }${refer?.qualification ? ` [${refer?.qualification}]` : ""}${
        refer?.city ? `- ${refer?.city}` : ""
      }${refer?.phone ? ` - ${refer?.phone}` : ""}`,
      value: refer?.full_name,
      email: refer?.email,
      phone: refer?.phone,
      address: refer?.address,
    }));
    const newAllCities = allCities?.cities?.map((el) => ({
      id: el?.id,
      title: el?.name,
      value: el?.name,
    }));
    setFieldOptions((prev) => ({
      ...prev,
      occupation: allOccupation?.occupations,
      education: allEducations?.educations,
      city: newAllCities,
      referrer: newReferDr,
    }));
  }, [allCities, allEducations, allOccupation, referDr]);

  // //set doctor and slot option

  const doSave = async (arr) => {
    const hasMissingId = arr?.some((report) => !report?.id);
    if (hasMissingId) {
      showToast(
        "Please select a test. Reports can't be saved without a test name.",
        "ERROR",
      );
      return;
    }

    const validInvestigations = arr.filter(
      (investigation) => investigation?.id || investigation?.name,
    );

    const reports = validInvestigations.map((investigation) => ({
      id: investigation?.id,
      ...(investigation?.reportId && { report_id: investigation.reportId }),
      value: investigation?.value || "",
      report_type: "investigation",
    }));

    // const finalReport = reports.filter((report) =>
    //   investigationList?.payload?.medical_tests.some(
    //     (inv) => inv.id === report.id
    //   )
    // );
    // console.log(reports)
    const hasEmptyValue = reports?.some((report) => !report?.value?.trim());

    // if (hasEmptyValue) {
    //   showToast("Every report must  have a value", "ERROR");
    //   return;
    // }
    // console.log(finalReport, "finalReport", reports, investigationList);

    // const reports = investigationArr?.map((investigation) => ({
    //   id: investigation.id,
    //   value: investigation?.value || "",
    // }));

    const destroyReports = toDeleteReportIds.map(({ id, reportId }) => ({
      id,
      report_id: reportId,
      _destroy: 1,
      report_type: "investigation",
    }));

    const data = {
      reports: [...reports, ...destroyReports],
      patient_id: patientDetailsData.id,
      appointment_id: appointmentData.id,
      state: "green",
    };
    let result = await updateMedicalTest(data);
    showToast(
      result.status.message || result.status.status,
      result.status.status,
    );
    if (result?.status?.status === "SUCCESS") {
      setToDeleteReportIds([]);
    }
  };

  const saveReport = async () => {
    if (isSaving) return;
    setIsSaving(true);
    try {
      if (!patientDetailsData?.id) {
        showToast("Please select a patient first.", "ERROR");
        return;
      }

      if (!appointmentData?.id) {
        showToast("Seems the patient doesn't have any appointment.", "ERROR");
        return;
      }

      if (investigationArr.length === 0) {
        showToast(
          "No investigations available to save report , Please select a patient first.",
          "ERROR",
        );
        return;
      }

      const seenIds = new Set();
      const dedupedArr = investigationArr.filter((r) => {
        if (!r.id || seenIds.has(r.id)) return false;
        seenIds.add(r.id);
        return true;
      });
      if (dedupedArr.length !== investigationArr.length) {
        const duplicates = investigationArr.filter((r) => !dedupedArr.includes(r));
        console.log("[saveReport] duplicates found:", duplicates);
        setDuplicateDialog({ open: true, duplicates, dedupedArr });
        return;
      }

      await doSave(investigationArr);
    } finally {
      setTimeout(() => {
        setIsSaving(false);
      }, 2500);
    }
  };

  const handleDeleteDuplicatesAndProceed = async () => {
    const { duplicates, dedupedArr } = duplicateDialog;
    setDuplicateDialog({ open: false, duplicates: [], dedupedArr: [] });
    setIsSaving(true);
    try {
      const reportIds = duplicates.filter((r) => r.reportId).map((r) => r.reportId);
      if (reportIds.length > 0) {
        await deleteExternalLabreportMultiple(reportIds);
      }
      setInvestigationArr(dedupedArr);
      await doSave(dedupedArr);
    } finally {
      setTimeout(() => {
        setIsSaving(false);
      }, 2500);
    }
  };

  const callBatchUpsert = async (formKey, formData) => {
    if (!patientDetailsData?.id || !appointmentData?.id) {
      showToast("Please select a patient and appointment first.", "ERROR");
      return;
    }
    const result = await batchUpsertClinicalData(
      patientDetailsData.id,
      appointmentData.id,
      { forms_to_be_updated: [formKey], [formKey]: formData },
    );
    showToast(
      result?.status?.message || result?.status?.status || "Saved",
      result?.status?.status || "SUCCESS",
    );
  };

  const saveAllergies = () =>
    callBatchUpsert("allergies", {
      nkda: nkda ? allergyNotes : false,
      ...(nkda
        ? {}
        : {
            items: allergyRows
              ?.filter((r) => r.agent?.value)
              .map((r) => ({
                type_of_allergy: r.type?.value || "",
                agent: r.agent?.value || "",
                start_date: r.startDate || "",
                reactions: r.reactions?.value || "",
                severity: r.severity?.value || "",
                comments: r.comments || "",
              })),
          }),
    });

  const savePastMedical = () => {
    const isNo = noPastMedical === "no_past_medical_history";
    callBatchUpsert("past_medical_hx", {
      no_past_medical_hx: isNo ? "1" : "0",
      diseases: isNo ? "" : pastMedicalSelected.join(", "),
      comments: pastMedicalComments,
    });
  };

  const addSurgicalProcedureFromChip = (procedure) => {
    setSurgicalRows((prev) => {
      const existingIdx = prev.findIndex(
        (r) => r.fromChip && r.procedure === procedure,
      );
      if (existingIdx !== -1)
        return prev.map((r, i) =>
          i === existingIdx ? { ...r, procedure: "", fromChip: false } : r,
        );
      const emptyIdx = prev.findIndex((r) => !r.procedure);
      if (emptyIdx !== -1)
        return prev.map((r, i) =>
          i === emptyIdx ? { ...r, procedure, fromChip: true } : r,
        );
      return [
        ...prev,
        { procedure, body_site: "", findings: "", date: "", fromChip: true },
      ];
    });
  };

  const savePastSurgical = () => {
    const isNo = noPastSurgical === "no_past_surgical_history";
    const allRows = [
      ...surgicalRows,
      ...(showMoreSurgeries ? surgicalMoreRows : []),
    ].filter((r) => r.procedure || r.body_site || r.findings || r.date);
    callBatchUpsert("past_surgical_hx", {
      no_past_surgical_hx: isNo ? "1" : "0",

      items: isNo
        ? []
        : allRows.map((r) => ({
            procedure: r.procedure,
            body_site: r.body_site,
            findings: r.findings,
            procedure_date: r.date,
            no_past_surgical_hx: isNo ? "1" : "0.0",
          })),
    });
  };

  const savePastDiagnostic = () => {
    const isNo = noPastDiagnostic === "no_past_diagnostic_history";
    const allRows = [
      ...diagnosticRows,
      ...(showMoreDiagnostic ? diagnosticMoreRows : []),
    ].filter((r) => r.procedure || r.body_site || r.findings || r.date);
    callBatchUpsert("past_diagnostic_hx", {
      no_past_diagnostic_hx: isNo ? "1" : "0",
      items: isNo
        ? []
        : allRows.map((r) => ({
            procedure: r.procedure,
            body_site: r.body_site,
            findings: r.findings,
            procedure_date: r.date,
            npdh: "0",
          })),
    });
  };

  const saveGynHistory = () => {
    const lmpField =
      gynLmpRadio === "lmp"
        ? { lmp: gynLmp }
        : gynLmpRadio === "hysterectomy"
          ? { hysterectomy: gynHysterectomy }
          : { menopause: gynMenopause };

    const birthControl =
      gynLmpRadio === "lmp"
        ? {
            none: gynBirthControl.none,
            pills: gynBirthControl.pills ? gynPillsText || true : false,
            btl: gynBirthControl.btl ? gynBtlText || true : false,
            vasectomy: gynBirthControl.vasectomy
              ? gynVasectomyText || true
              : false,
            condoms: gynBirthControl.condoms,
            contraceptive_ring: gynBirthControl.contraceptiveRing,
            attempting_pregnancy: gynBirthControl.attemptingPregnancy,
            implanon: gynBirthControl.implanon
              ? gynImplanonText || true
              : false,
            iud: gynBirthControl.iud ? gynIudType || true : false,
            "Insert Date": gynIudInsertDate || "",
            "Removal Date": gynIudRemovalDate || "",
            others: gynBirthControl.others ? gynOthersText || true : false,
          }
        : {};

    callBatchUpsert("gyn_hx", {
      ...lmpField,
      abnormal_pap: gynAbnormalPap,
      total_pregnancies: gynTotalPregnancies,
      treatment: gynTreatment,
      menstrual_history: {
        menarche: gynMenarche,
        cycle: gynCycle,
        cycle_duration: gynCycleDuration,
        flow: gynFlow,
        cramps: gynCramps,
        menstrual_problems: gynMenstrualProblems,
      },
      birth_control: birthControl,
    });
  };

  const savePastPregnancies = () => {
    const allRows = pregnancyRows.filter(
      (r) =>
        r.date ||
        r.ga_weeks ||
        r.birth_weight ||
        r.type_of_delivery ||
        r.place_of_delivery ||
        r.preterm_labor ||
        r.outcome ||
        r.comments,
    );
    callBatchUpsert("past_pregnancies_hx", { items: allRows });
  };

  const saveFamilyHistory = () => {
    const formatStaticMember = (data) => ({
      age: data.age,
      living_status: data.livingStatus,
      diseases: Object.entries(data.checked)
        .filter(([, v]) => v)
        .map(([k]) => k),
    });
    const formatSelectMember = (col) => ({
      relation: col.relation,
      age: col.age,
      living_status: col.livingStatus,
      diseases: Object.entries(col.checked)
        .filter(([, v]) => v)
        .map(([k]) => k),
      malignancy: col.extraInputs?.["Malignancy"] || "",
    });

    if (noFamilyIllness) {
      callBatchUpsert("family_history", {
        no_family_illness: true,
        comments: familyComments,
      });
    } else {
      callBatchUpsert("family_history", {
        no_family_illness: false,
        father: formatStaticMember(familyStaticData.father),
        mother: formatStaticMember(familyStaticData.mother),
        members: familyDefaultSelectCols
          .concat(familyExtraCols)
          .filter((c) => c.relation)
          .map(formatSelectMember),
        comments: familyComments,
      });
    }
  };

  const saveSocialHistory = () =>
    callBatchUpsert("social_hx", {
      maritalstatus: socialMaritalStatus,
      occupation: socialOccupation,
      industry: socialIndustry,
      generalstresslevel: socialStress,
      diet: socialDiet,
      caffeineintake: socialCaffeineIntake,
      tobacco_status: socialTobaccoSmoking,
      tobacco_quan: socialTobaccoSmokingQty,
      tobacco_quit_duration: socialTobaccoSmokingDuration,
      chewing_status: socialTobaccoChewing,
      chewing_quan: socialTobaccoChewingQty,
      chewing_quit_duration: socialTobaccoChewingDuration,
      alcohol: socialAlcohol,
      alcohol_yes: socialAlcoholIfYes,
      alcohol_quit_duration: socialAlcoholDuration,
      drugs: socialDrugs,
      drugs_yes: socialDrugsSelected.join(", "),
      drugs_quit_duration: socialDrugsDuration,
      excercise: socialExercise,
      comments: socialComments,
    });

  const handleFormChange = (event, value, name) => {
    let fieldName;

    if (event) {
      fieldName = event.target.name;
      const { name: eventName, value: eventValue } = event.target;
      setFormState((prevState) => ({
        ...prevState,
        [eventName]: eventValue,
      }));
    } else if (name) {
      if (value?.value === "other") {
        setShowNewValueField((prev) => ({ ...prev, [name]: true }));
      } else {
        setFormState((prevState) => ({
          ...prevState,
          [name]: value,
        }));
        setShowNewValueField((prev) => ({ ...prev, [name]: false }));
      }
    }
    setErrors((prev) => ({ ...prev, [fieldName]: undefined }));
  };

  // handle check box
  const handleCheckBox = (field) => {
    const currentValue = formState[field];
    const newValue = currentValue === false ? true : false;
    setFormState((prevState) => ({ ...prevState, [field]: newValue }));
  };

  //add new value to occupation education and cities also post req
  const handleAddNewValue = async (name) => {
    if (newValues[name]) {
      const newValue = newValues[name];

      let newObj = {
        id: `${Math.floor(Math.random() * 90) + 10}${newValue}`,
        value: newValue,
        title: newValue,
      };
      await addOptionInAppointForm({ value: newValue }, name);
      if (name === "occupation") {
        refetchOccupation();
      } else if (name === "education") {
        refetchEducation();
      } else {
        refetchCities();
      }
      setFormState((prevState) => ({
        ...prevState,
        [name]: newObj,
      }));
      // dispatch(setSelectedSlot({ date: newValue, slot: "" }));
      setFieldOptions((prevOptions) => ({
        ...prevOptions,
        [name]: [...(prevOptions[name] || []), newObj],
      }));
      setNewValues((prev) => ({ ...prev, [name]: "" }));
      setShowNewValueField((prev) => ({ ...prev, [name]: false }));
    }
  };

  // console.log(formState, 'FormState');
  // console.log(fieldOptions, 'fieldOptions');

  const handleAddOrEditValue = (name, referrer) => {
    const newReferrer = {
      id: referrer?.id,
      title: `${referrer?.full_name || ""} - ${referrer?.address || ""} - ${
        referrer?.phone || ""
      }`,
      value: referrer?.full_name || "",
      address: referrer?.address || "",
      email: referrer?.email || "",
      phone: referrer?.phone || "",
    };

    setFieldOptions((prev) => ({
      ...prev,
      referrer: [...(prev.referrer || []), newReferrer],
    }));

    setTimeout(() => {
      setFormState((prevState) => ({
        ...prevState,
        [name]: referrer?.id,
      }));
      refetchReferrer();
    }, 100);
  };

  const handleModal = (val) => {
    setOpenModal(val);
  };

  useEffect(() => {
    if (appointmentData || patientDetailsData) {
      const patientObj = {
        height: appointmentData?.height,
        weight: appointmentData?.weight,
        fever: appointmentData?.fever,
        bps: appointmentData?.bp_s,
        bpd: appointmentData?.bp_d,
        bmi: appointmentData?.bmi,
        smoking: appointmentData?.smoking,
        tobacco: appointmentData?.tobacco,
        alcohol: appointmentData?.alcohol,
        pulse_rate: appointmentData?.pulse_rate,
        heart_rate: appointmentData?.heart_rate,
        pain_level: appointmentData?.pain_level,
        spo2: appointmentData?.spo2,
        comments: appointmentData?.comments,
        referrer:
          patientDetailsData?.appointments?.[0]?.referrer_id ||
          patientDetailsData?.referrer_id ||
          null,
        ready_investigations: appointmentData?.ready_investigations,
        ready_investigations_prev: appointmentData?.ready_investigations,
      };
      setDrConsultId(appointmentData?.consultant?.id);
      // setInvestigationArr(
      //   appointmentData?.ready_investigations?.map((item) => ({
      //     id: item?.id,
      //     name: item?.name,
      //     value: item?.after_value,
      //     isDisabled: item?.after_value ? true : false,
      //   })) || []
      // );
      setFormState((prev) => ({ ...prev, ...patientObj }));
      setToDeleteReportIds([]);
    }
  }, [patientDetailsData, appointmentData]);

  const [investigationArr, setInvestigationArr] = useState(
    quickCheckTestReports?.payload?.medical_test_reports?.map((item) => ({
      id: item?.medical_test_id,
      name: item?.test_name,
      value: item?.value,
      isDisabled: appointmentData?.prescription,
    })) || [],
  );
  const [toDeleteReportIds, setToDeleteReportIds] = useState([]);

  useEffect(() => {
    if (quickCheckTestReports) {
      const reportsData =
        quickCheckTestReports?.payload?.medical_test_reports?.map((item) => ({
          reportId: item?.id,
          id: item?.medical_test_id,
          name: item?.test_name,
          value: item?.value,
          isDisabled: appointmentData?.prescription,
        })) || [];
      if (reportsData?.length) {
        const finalReport = reportsData.filter((report) =>
          investigationList?.payload?.medical_tests?.some(
            (inv) => inv.id === report.id,
          ),
        );
        setInvestigationArr(finalReport);
      }
    }
  }, [investigationList?.payload?.medical_tests, quickCheckTestReports]);

  // console.log(investigationArr, "investigationArr");

  useEffect(() => {
    if (!investigationList?.payload?.medical_tests) return;

    const defaultInv = investigationList.payload.medical_tests.filter(
      (item) => item.isinvestigation,
    );

    // if (quickCheckTestReports?.payload?.medical_test_reports?.length === 0) {
    //   setInvestigationArr((prev) => [...prev, ...defaultInv]);
    // }

    if (quickCheckTestReports?.payload?.medical_test_reports?.length === 0) {
      setInvestigationArr((prev) => {
        const existingIds = prev.map((item) => item.id); // Get IDs of existing items
        const newItems = defaultInv
          .filter((item) => !existingIds.includes(item.id)) // Add only if not already present
          .map((item) => ({
            ...item,
            disable: appointmentData?.prescription,
            value: "",
          }));
        return [...newItems];
      });
    }
  }, [investigationList, quickCheckTestReports]);

  // console.log(appointmentData , 'appointmentData');
  // console.log(patientDetailsData , 'patientDetailsData');
  //  console.log(formState , 'formsState');

  // const handleInputChange = (event, newInputValue) => {

  //     // console.log(formS)

  // };

  const handleInputChange = (event, value, name) => {
    //  console.log("Event:", event, "Value:", value, "Name:", name);
    let fieldName;
    setInputValue(value);
    if (event) {
      const { name: eventName, value: eventValue } = event.target;
      fieldName = event.target.name;
      setFormState((prevState) => ({
        ...prevState,
        [eventName]: eventValue,
      }));
    } else if (name) {
      fieldName = name;
      if (value?.value === "other") {
        setFormState((prev) => ({ ...prev, [name]: true }));
      } else if (name === "referrer") {
        setFormState((prevState) => ({
          ...prevState,
          [name]: value?.id || value,
        }));

        setInputValue(value);
      } else {
        setFormState((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }
    }
    setErrors((prev) => ({ ...prev, [fieldName]: undefined }));
  };

  const handleUpdatePatient = async () => {
    // console.log(formState);

    // if (!validateForm(formState)) {
    //   return null;
    // }

    if (patientDetailsData?.id) {
      if (appointmentData?.id) {
        let data = {
          appointment: {
            consultant_id: formState?.consultant_id,
            doctor_id: formState?.doctor_id,
            appointment_slot_id: formState?.slot,
            referrer_id: formState?.referrer?.id || formState?.referrer || null,
            // state: "green",
            visit_date: formState?.visit_date,
            visit_type: formState?.visit_date,
            height: formState?.height,
            weight: formState?.weight,
            fever: formState?.fever,
            bp_s: formState?.bps,
            bp_d: formState?.bpd,
            bmi: formState?.bmi,
            smoking: formState?.smoking,
            tobacco: formState?.tobacco,
            alcohol: formState?.alcohol,
            pulse_rate: formState?.pulse_rate,
            heart_rate: formState?.heart_rate,
            pain_level: formState?.pain_level,
            spo2: formState?.spo2,
            comments: formState?.comments,
          },
        };
        let result = await updatePatientAppointment(data, appointmentData?.id);
        showToast(
          ` ${result?.status?.message || result?.status?.status} `,
          result?.status?.status,
        );
        if (result?.status?.status) {
          // dispatch(setPatientDetailsData({}));
          // dispatch(setAppointmentData({}));
          // setFormState({});
          dispatch(setAppointmentData(result?.payload));
        }
      } else {
        showToast("patient does not have any appointment ", "ERROR");
      }
    } else {
      showToast("select patient", "ERROR");
    }
  };

  const handleInvestigationChange = (index, value) => {
    setFormState((prev) => ({
      ...prev,
      ready_investigations: prev.ready_investigations.map((item, i) =>
        i === index
          ? {
              ...item,
              after_value: value,
            }
          : item,
      ),
    }));
  };

  const handleAddTest = () => {
    setInvestigationArr([
      ...investigationArr,
      {
        id: "",
        name: "",
        value: "",
        isDisabled: false,
        // isDisabled: appointmentData?.prescription
        // prescription_id
      },
    ]);
  };

  // console.log(appointmentData?.prescription, 'appointmentData?.prescription_id');

  const handleDeleteTest = (index) => {
    const item = investigationArr[index];
    if (item?.reportId) {
      setToDeleteReportIds((prev) => [
        ...prev,
        { id: item.id, reportId: item.reportId },
      ]);
    }
    setInvestigationArr((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSelectTest = (index, newValue) => {
    setInvestigationArr((prev) => {
      const updatedArr = [...prev];
      updatedArr[index] = {
        ...updatedArr[index],
        id: newValue?.value,
        name: newValue?.label,
      };
      return updatedArr;
    });
  };

  const handleTestValueChange = (index, newValue) => {
    // console.log(index, newValue, "index , newValue");
    setInvestigationArr((prev) => {
      const updatedArr = [...prev];
      // Update only the value field for the specified index
      updatedArr[index] = {
        ...updatedArr[index],
        value: newValue || "", // Use an empty string if newValue is null/undefined
      };
      return updatedArr;
    });
  };

  const renderField = (field) => {
    switch (field.field) {
      case "Autocomplete1":
        return (
          <>
            {/* {console.log(formState[field.name])} */}
            <Autocomplete
              options={fieldOptions[field.name] || field.options}
              clearIcon={false}
              popupIcon={false}
              getOptionLabel={(option) =>
                option.title && option.value ? `${option.title} ` : ""
              }
              // value={formState[field.name] || ""}
              // value={
              //   (formState[field.name] &&
              //     (fieldOptions[field.name] || field.options)?.find(
              //       (option) =>
              //         option.value ===
              //         (formState[field.name]?.value ||
              //           formState[field.name]) ||
              //         option.title ===
              //         (formState[field.name]?.title ||
              //           formState[field.name]) ||
              //         option.id === formState[field.name]
              //     )) ||
              //   formState[field.name]
              // }

              value={
                (formState[field.name] &&
                  (
                    fieldOptions[field.name] ||
                    fieldOptions.referrer ||
                    []
                  )?.find((option) => option.id === formState[field.name])) ||
                null
              }
              onChange={(event, newValue) =>
                // handleInputChange( field.name , newValue)
                // handleFormChange(event, newValue ,field.name)
                handleInputChange(null, newValue, field.name)
              }
              PopperComponent={(props) => (
                <Popper
                  {...props}
                  sx={{
                    maxHeight: "578.51px",
                    overflowY: "auto",
                    minWidth: "400px",
                    zIndex: 1300,
                  }}
                  placement="bottom-start"
                />
              )}
              renderOption={(props, option, { index }) => (
                <MenuItem
                  {...props}
                  sx={{
                    ...menuItemStyle,
                    // "&:hover": {
                    //   backgroundColor: "#0067FF40 !important",
                    //   borderRadius: "16px",
                    //   color: "black !important",
                    // },
                    // ...(index === 0 && {
                    //   backgroundColor: "#0067FF40 !important",
                    //   color: "black !important",
                    //   borderRadius: "16px",
                    // }),
                  }}
                >
                  {option.title}
                </MenuItem>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={field.placeholder}
                  variant={field.variant}
                  fullWidth
                  sx={textfieldText}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {params?.InputProps?.endAdornment}
                        <IconButton onClick={() => handleModal(true)}>
                          <EditNoteIcon />
                        </IconButton>
                      </>
                    ),
                  }}
                />
              )}
            />

            <CustomModal open={openModal} onClose={() => setOpenModal(false)}>
              <Referrer
                // selectedReferrer={formState["referrer"]}
                // selectedReferrer={formState["referrer"]}
                selectedReferrer={
                  (formState[field.name] &&
                    (fieldOptions.referrer || fieldOptions[field.name])?.find(
                      (option) =>
                        option.value === formState[field.name]?.value ||
                        option.id === formState[field.name],
                    )) ||
                  formState[field.name]
                }
                setOpenModal={setOpenModal}
                onSave={handleAddOrEditValue}
              />
            </CustomModal>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <Grid
        container
        marginBottom={"auto"}
        lg={3.8}
        md={3.8}
        sm={5.5}
        sx={{
          padding: "20px",
          border: "2px solid #E1E1E1",
          borderRadius: "20px",
          height: "calc(100vh - 120px)",
          overflowY: "auto",
          alignContent: "flex-start",
          // backgroundColor: "neutral.blueShadeBg",
        }}
      >
        <Accordion
          expanded={expandedGeneral}
          onChange={(event, isExpanded) => setExpandedGeneral(isExpanded)}
          sx={{
            width: "100%",
            borderRadius: "10px",
            boxShadow: "none",
            border: "1px solid #E1E1E1",
            "&:before": { display: "none" },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              backgroundColor: "neutral.white",
              borderRadius: "16px",
              minHeight: "52px",
              "& .MuiAccordionSummary-content": {
                alignItems: "center",
                margin: "12px 0",
              },
              "& .MuiAccordionSummary-expandIconWrapper": {
                alignSelf: "center",
              },
            }}
          >
            <Box sx={{ alignItems: "center", display: "flex", gap: 2 }}>
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  backgroundColor: "neutral.blackBorder",
                  borderRadius: "50%",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <EditNoteIcon sx={{ color: "#0097B2" }} />
              </Box>
              <Box>
                <Typography fontWeight={600}>
                  Update Patient General Info
                </Typography>
              </Box>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Grid
              item
              sx={{
                paddingY: "6px",
                borderRadius: "20px",
                width: "100%",
              }}
            >
              {/* {"-----Patient Form----"}  */}
              <Grid container spacing={1.5}>
                {allFormFields
                  ?.slice(allFormFields.length - 1, allFormFields.length)
                  .map((field) => (
                    <Grid item {...field.gridProps} key={field.id}>
                      {field.isTitle && (
                        <TextView variant="title_medium">
                          {field.isTitle}
                        </TextView>
                      )}
                      {renderField(field)}
                    </Grid>
                  ))}
              </Grid>

              <Grid
                item
                xs={12}
                sm={8}
                sx={{ marginTop: "2rem", marginBottom: "1rem" }}
              >
                <TextView variant={"heading2"}>Conditions</TextView>
              </Grid>

              <Grid container spacing={1}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    type="text"
                    name="height"
                    placeholder="Height (Ft 'In)"
                    sx={textfieldTextPrep}
                    variant="outlined"
                    value={formState?.height || ""}
                    onChange={handleFormChange}
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    placeholder="Weight"
                    type="text"
                    name="weight"
                    sx={textfieldTextPrep}
                    variant="outlined"
                    value={formState?.weight || ""}
                    onChange={handleFormChange}
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    type="text"
                    name="fever"
                    placeholder="Fever"
                    sx={textfieldTextPrep}
                    variant="outlined"
                    value={formState?.fever || ""}
                    onChange={handleFormChange}
                  />
                </Grid>

                <Grid item xs={12} sm={2}>
                  <TextField
                    fullWidth
                    placeholder="BP S"
                    type="text"
                    name="bps"
                    sx={textfieldTextPrep}
                    variant="outlined"
                    value={formState?.bps || ""}
                    onChange={handleFormChange}
                  />
                </Grid>

                <Grid item xs={12} sm={2.1}>
                  <TextField
                    fullWidth
                    type="text"
                    name="bpd"
                    placeholder="BP D"
                    sx={textfieldTextPrep}
                    variant="outlined"
                    value={formState?.bpd || ""}
                    onChange={handleFormChange}
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    placeholder="BMI"
                    type="text"
                    name="bmi"
                    sx={textfieldTextPrep}
                    variant="outlined"
                    value={formState?.bmi || ""}
                    onChange={handleFormChange}
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Box
                    display="flex"
                    alignItems="center"
                    mb={2}
                    onClick={() => handleCheckBox("smoking")}
                  >
                    <Typography
                      variant="title1_medium"
                      sx={{ marginRight: -1, marginLeft: "10px" }}
                    >
                      Smoking
                    </Typography>
                    <Checkbox name="smoking" checked={!!formState?.smoking} />
                  </Box>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Box
                    display="flex"
                    alignItems="center"
                    mb={2}
                    onClick={() => handleCheckBox("tobacco")}
                  >
                    <Typography
                      variant="title1_medium"
                      sx={{ marginRight: -1 }}
                    >
                      Tobacco
                    </Typography>
                    <Checkbox name="tobacco" checked={!!formState?.tobacco} />
                  </Box>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Box
                    display="flex"
                    alignItems="center"
                    mb={2}
                    onClick={() => handleCheckBox("alcohol")}
                  >
                    <Typography
                      variant="title1_medium"
                      sx={{ marginRight: -1 }}
                    >
                      Alcohol
                    </Typography>
                    <Checkbox name="alcohol" checked={!!formState?.alcohol} />
                  </Box>
                </Grid>
              </Grid>

              <Grid item xs={12} sx={{ mt: 1.5 }}>
                <Divider />
              </Grid>

              <Grid
                item
                xs={12}
                sm={8}
                sx={{ marginTop: "1rem", marginBottom: "0.5rem" }}
              >
                <TextView variant={"heading2"}>Others</TextView>
              </Grid>

              <Grid container spacing={1}>
                <Grid item xs={12} sm={3}>
                  <TextField
                    fullWidth
                    type="text"
                    name="pulse_rate"
                    placeholder="Pulse Rate (bpm)"
                    sx={textfieldTextPrep}
                    variant="outlined"
                    value={formState?.pulse_rate || ""}
                    onChange={handleFormChange}
                  />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <TextField
                    fullWidth
                    type="text"
                    name="heart_rate"
                    placeholder="Heart Rate (bpm)"
                    sx={textfieldTextPrep}
                    variant="outlined"
                    value={formState?.heart_rate || ""}
                    onChange={handleFormChange}
                  />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <TextField
                    fullWidth
                    type="text"
                    name="pain_level"
                    placeholder="Pain Level (0-10)"
                    sx={textfieldTextPrep}
                    variant="outlined"
                    value={formState?.pain_level || ""}
                    onChange={handleFormChange}
                  />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <TextField
                    fullWidth
                    type="text"
                    name="spo2"
                    placeholder="SpO2 (%)"
                    sx={textfieldTextPrep}
                    variant="outlined"
                    value={formState?.spo2 || ""}
                    onChange={handleFormChange}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    multiline
                    minRows={3}
                    type="text"
                    name="comments"
                    placeholder="Comments"
                    sx={{
                      ...textfieldTextPrep,
                      "& .MuiOutlinedInput-root": {
                        ...textfieldTextPrep["& .MuiOutlinedInput-root"],
                        height: "auto",
                        padding: "9px !important",
                      },
                    }}
                    variant="outlined"
                    value={formState?.comments || ""}
                    onChange={handleFormChange}
                  />
                </Grid>
              </Grid>

              <Box sx={{ ...buttonWrapper }}>
                <Button
                  onClick={handleUpdatePatient}
                  variant="contained"
                  sx={{ ...primaryBtnTeal, fontSize: "13px", p: 1.2 }}
                  disabled={isLoading}
                >
                  Update Info
                </Button>
              </Box>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expandedInvestigations}
          onChange={(event, isExpanded) =>
            setExpandedInvestigations(isExpanded)
          }
          sx={{
            width: "100%",
            mt: 2,
            borderRadius: "10px",
            boxShadow: "none",
            border: "1px solid #E1E1E1",
            overflow: "hidden",
            "&:before": { display: "none" },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              backgroundColor: "neutral.white",
              borderRadius: "12px",
              minHeight: "56px",
              "& .MuiAccordionSummary-content": {
                alignItems: "center",
                margin: "12px 0",
              },
              "& .MuiAccordionSummary-expandIconWrapper": {
                alignSelf: "center",
              },
            }}
          >
            <Box sx={{ alignItems: "center", display: "flex", gap: 2 }}>
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  backgroundColor: "neutral.blackBorder",
                  borderRadius: "50%",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <AddCircleOutlineRoundedIcon sx={{ color: "#0097B2" }} />
              </Box>
              <Box>
                <Typography fontWeight={600}>
                  Doctor Default Investigations
                </Typography>
              </Box>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Grid
              item
              sx={{
                padding: "0rem",
                borderRadius: "20px",
                width: "100%",
              }}
              sm={12}
            >
              <Grid
                container
                spacing={1}
                sx={{
                  paddingX: "0px",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Grid sx={{ paddingLeft: 0 }} item xs={6} sm={6} md={6} lg={6}>
                  <Typography
                    variant="title1_medium"
                    fontSize={"17px"}
                    fontWeight={700}
                  >
                    Test Name
                  </Typography>
                </Grid>

                <Grid sx={{ paddingLeft: 0 }} item xs={5} sm={5} md={5} lg={5}>
                  <Typography
                    fontWeight={700}
                    variant="title1_medium"
                    fontSize={"17px"}
                  >
                    Value
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs={1}
                  sm={1}
                  md={1}
                  lg={1}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <IconButton
                    sx={{
                      ...orangeButton,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    onClick={handleAddTest}
                  >
                    <AddIcon
                      sx={{
                        width: 24,
                        height: 24,
                        color: "neutral.white",
                      }}
                    />
                  </IconButton>
                </Grid>
              </Grid>

              {investigationArr?.map((test, index) => (
                <Grid
                  container
                  spacing={1}
                  key={index}
                  sx={{
                    marginBottom: "7px",
                    paddingX: "0px",
                    marginTop: index === 0 ? "4px" : "",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Grid item xs={6} sm={6} md={6} lg={6}>
                    <Autocomplete
                      clearIcon={false}
                      noOptionsText="No investigation found"
                      disabled={test?.isDisabled}
                      fullWidth
                      options={
                        investigationList?.payload?.medical_tests
                          ?.filter(
                            (item) =>
                              !investigationArr?.some(
                                (inv) => inv?.id === item?.id,
                              ),
                          )
                          ?.map((item) => ({
                            value: item?.id,
                            label: item?.name,
                          })) || []
                      }
                      getOptionLabel={(option) =>
                        option.label || option.name || test?.name
                      }
                      value={
                        (investigationList?.payload?.medical_tests || [])?.find(
                          (item) =>
                            item?.id === test?.id || item?.name === test?.name,
                        ) || test?.name
                      }
                      onChange={(event, newValue) =>
                        handleSelectTest(index, newValue)
                      }
                      PopperComponent={(props) => (
                        <Grid item lg={8}>
                          <Popper
                            {...props}
                            placement="bottom-start"
                            style={menuItemStyleContentWidth}
                          />
                        </Grid>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Test"
                          variant="outlined"
                          fullWidth
                          sx={textfieldText}
                        />
                      )}
                      renderOption={(props, option) => (
                        <MenuItem sx={menuItemStyle} {...props} key={option.id}>
                          {option.label}
                        </MenuItem>
                      )}
                    />
                  </Grid>

                  <Grid
                    sx={{ paddingLeft: 0 }}
                    item
                    xs={5}
                    sm={5}
                    md={5}
                    lg={5}
                  >
                    <TextField
                      value={test?.value}
                      placeholder=" Test value"
                      fullWidth
                      onChange={(event) =>
                        handleTestValueChange(index, event.target.value)
                      }
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          padding: "6px",
                          height: "40px",
                          borderRadius: "10px",
                          backgroundColor: "white",
                        },
                        "&:hover": {
                          boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                          borderRadius: "15px",
                        },
                        "& .MuiInputBase-input": {
                          padding: "0px 4PX",
                        },
                        "& fieldset": {
                          border: "neutral.blackBorder",
                        },
                        "&:hover fieldset": {
                          border: "neutral.blackBorder",
                        },
                      }}
                      disabled={test?.isDisabled}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={1}
                    sm={1}
                    md={1}
                    lg={1}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {!test?.isDisabled && (
                      <IconButton
                        sx={{
                          width: 40,
                          height: 40,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        onClick={() => handleDeleteTest(index)}
                      >
                        <CloseIcon
                          sx={{
                            ...xBtn,
                            width: 22,
                            height: 22,
                          }}
                        />
                      </IconButton>
                    )}
                  </Grid>
                </Grid>
              ))}

              <Box
                sx={{
                  margin: "0px",
                  width: "100%",
                  mt: 2,
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  variant="contained"
                  sx={{ ...primaryBtnTeal, fontSize: "13px", p: 1.2 }}
                  onClick={saveReport}
                  disabled={isSaving}
                >
                  {isSaving ? "Saving..." : "Save"}
                </Button>
              </Box>
            </Grid>
          </AccordionDetails>
        </Accordion>
        {isClinicalDataEnabled && (
          <>
            {/* Chief Complaint Accordion */}
            <Accordion
              expanded={expandedChiefComplaint}
              onChange={(event, isExpanded) =>
                setExpandedChiefComplaint(isExpanded)
              }
              sx={{
                width: "100%",
                borderRadius: "10px",
                boxShadow: "none",
                border: "1px solid #E1E1E1",
                "&:before": { display: "none" },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  backgroundColor: "neutral.white",
                  borderRadius: "16px",
                  minHeight: "52px",
                  "& .MuiAccordionSummary-content": {
                    alignItems: "center",
                    margin: "12px 0",
                  },
                  "& .MuiAccordionSummary-expandIconWrapper": {
                    alignSelf: "center",
                  },
                }}
              >
                <Box sx={{ alignItems: "center", display: "flex", gap: 2 }}>
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      backgroundColor: "neutral.blackBorder",
                      borderRadius: "50%",
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    <ReportProblemOutlinedIcon sx={{ color: "#0097B2" }} />
                  </Box>
                  <Box>
                    <Typography fontWeight={600}>Chief Complaint</Typography>
                  </Box>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={2} sx={{ pt: 1 }}>
                  <Grid item xs={12}>
                    <Select
                      placeholder="Select complaint..."
                      options={complaintOptions}
                      value={chiefComplaintForm.complaint}
                      onChange={(val) =>
                        setChiefComplaintForm((prev) => ({
                          ...prev,
                          complaint: val,
                        }))
                      }
                      styles={selectStyles}
                      menuPortalTarget={document.body}
                      isMulti
                      isClearable
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      placeholder="e.g. 3 days, 2 weeks"
                      variant="outlined"
                      sx={textfieldTextPrep}
                      value={chiefComplaintForm.duration}
                      onChange={(e) =>
                        setChiefComplaintForm((prev) => ({
                          ...prev,
                          duration: e.target.value,
                        }))
                      }
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      placeholder="Additional comments..."
                      variant="outlined"
                      multiline
                      minRows={3}
                      sx={{
                        ...textfieldTextPrep,
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "10px",
                          backgroundColor: "white",
                        },
                      }}
                      value={chiefComplaintForm.comments}
                      onChange={(e) =>
                        setChiefComplaintForm((prev) => ({
                          ...prev,
                          comments: e.target.value,
                        }))
                      }
                    />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: 1,
                      flexWrap: "wrap",
                    }}
                  >
                    <Button
                      variant="contained"
                      sx={{ ...primaryBtnTeal, fontSize: "13px", p: 1.2 }}
                      disabled={isLoading}
                      onClick={() =>
                        callBatchUpsert("chief_complaints", {
                          complaint: Array.isArray(chiefComplaintForm.complaint)
                            ? chiefComplaintForm.complaint
                                .map((c) => c.value)
                                .join(", ")
                            : chiefComplaintForm.complaint?.value || "",
                          duration: chiefComplaintForm.duration,
                          comments: chiefComplaintForm.comments,
                        })
                      }
                    >
                      <SaveIcon sx={{ width: 15, height: 15 }} />
                      Save
                    </Button>
                    {/* 
                <Button
                  variant="contained"
                  sx={{
                    ...primaryBtnTeal,
                    gap: 0.6,
                    fontSize: "13px",
                    p: 1.2,
                  }}
                  onClick={() => {
                    setExpandedChiefComplaint(false);
                    setExpandedGeneral(true);
                  }}
                  disabled={isLoading}
                >
                  <SaveIcon sx={{ width: 15, height: 15 }} />
                  <ArrowForwardIcon sx={{ width: 14, height: 14 }} />
                  Save & Continue
                </Button> */}

                    {/* <Button
                  variant="contained"
                  sx={{
                    ...primaryBtnTeal,
                    gap: 0.6,
                    fontSize: "13px",
                    p: 1.2,
                    backgroundColor: "neutral.grey",
                    border: "2px solid #90A4AE",
                    "&:hover": {
                      backgroundColor: "#546E7A",
                      border: "2px solid #546E7A",
                    },
                  }}
                  onClick={() => {
                    setExpandedChiefComplaint(false);
                    setExpandedGeneral(true);
                  }}
                  disabled={isLoading}
                >
                  Continue
                  <ArrowForwardIcon sx={{ width: 15, height: 15 }} />
                </Button> */}
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>

            {/* Allergies Accordion */}
            <Accordion
              expanded={expandedAllergies}
              onChange={(e, isExpanded) => setExpandedAllergies(isExpanded)}
              sx={{
                width: "100%",
                mt: 2,
                borderRadius: "10px",
                boxShadow: "none",
                border: "1px solid #E1E1E1",
                overflow: "hidden",
                "&:before": { display: "none" },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  backgroundColor: "neutral.white",
                  borderRadius: "16px",
                  minHeight: "52px",
                  "& .MuiAccordionSummary-content": {
                    alignItems: "center",
                    margin: "12px 0",
                  },
                  "& .MuiAccordionSummary-expandIconWrapper": {
                    alignSelf: "center",
                  },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      backgroundColor: "neutral.blackBorder",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <ReportProblemOutlinedIcon sx={{ color: "#0097B2" }} />
                  </Box>
                  <Typography fontWeight={600}>Allergies</Typography>
                </Box>
              </AccordionSummary>

              <AccordionDetails sx={{ p: 1.5 }}>
                {/* NKDA row */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1.5,
                    mb: 1.5,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      mt: 0.8,
                      flexShrink: 0,
                    }}
                  >
                    <Checkbox
                      checked={nkda}
                      onChange={(e) => setNkda(e.target.checked)}
                      sx={{
                        p: 0.5,
                        color: "#0097B2",
                        "&.Mui-checked": { color: "#0097B2" },
                      }}
                    />
                    <Typography variant="body2" fontWeight={500}>
                      NKDA
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <TextField
                      fullWidth
                      multiline
                      minRows={2}
                      variant="outlined"
                      disabled={!nkda}
                      value={allergyNotes}
                      onChange={(e) => {
                        if (e.target.value.length <= 300)
                          setAllergyNotes(e.target.value);
                      }}
                      inputProps={{ maxLength: 300 }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "8px",
                          backgroundColor: nkda ? "white" : "#f0f0f0",
                          fontSize: "13px",
                        },
                      }}
                    />
                    <Typography
                      variant="caption"
                      sx={{ color: "#0097B2", ml: 0.5 }}
                    >
                      {300 - allergyNotes.length}
                    </Typography>
                  </Box>
                </Box>

                {/* Row count selector — hidden when NKDA checked */}
                {!nkda && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      mb: 1.5,
                      gap: 1,
                    }}
                  >
                    <select
                      value={allergyExtraRows}
                      onChange={(e) =>
                        setAllergyExtraRows(Number(e.target.value))
                      }
                      style={{
                        border: "1px solid #B0BEC5",
                        borderRadius: "6px",
                        fontSize: "13px",
                        padding: "3px 8px",
                        backgroundColor: "white",
                        color: "#333",
                        cursor: "pointer",
                        outline: "none",
                        fontFamily: "Lato, sans-serif",
                        minWidth: "70px",
                      }}
                    >
                      <option value={0}>More</option>
                      {Array.from({ length: 15 }, (_, i) => (
                        <option key={i + 1} value={i + 1}>
                          {i + 1}
                        </option>
                      ))}
                    </select>
                  </Box>
                )}

                {/* All allergy rows */}
                {allergyRows.map((row, idx) => (
                  <AllergyRow
                    key={idx}
                    data={row}
                    onChange={(updated) => updateAllergyRow(idx, updated)}
                    disabled={nkda}
                  />
                ))}

                {/* Extra rows added by selector */}
                {!nkda && allergyExtraRows > 0 && (
                  <Box sx={{ mt: 1, pt: 1, borderTop: "2px dashed #E1E1E1" }}>
                    {Array.from({ length: allergyExtraRows }, (_, i) => (
                      <AllergyRow
                        key={`extra-${i}`}
                        data={allergyRows[3 + i] || emptyAllergyRow()}
                        onChange={(updated) => updateAllergyRow(3 + i, updated)}
                        disabled={false}
                      />
                    ))}
                  </Box>
                )}

                {/* Buttons */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 1,
                    mt: 2,
                    flexWrap: "wrap",
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      ...primaryBtnTeal,
                      gap: 0.6,
                      fontSize: "13px",
                      p: 1.2,
                    }}
                    onClick={saveAllergies}
                  >
                    <SaveIcon sx={{ width: 15, height: 15 }} />
                    Save
                  </Button>
                  {/* <Button
                variant="contained"
                sx={{ ...primaryBtnTeal, gap: 0.6, fontSize: "13px", p: 1.2 }}
                onClick={() => {
                  saveAllergies();
                  setExpandedAllergies(false);
                  setExpandedChiefComplaint(true);
                }}
              >
                <SaveIcon sx={{ width: 15, height: 15 }} />
                <ArrowForwardIcon sx={{ width: 14, height: 14 }} />
                Save & Continue
              </Button> */}
                  {/* <Button
                variant="contained"
                sx={{
                  ...primaryBtnTeal,
                  gap: 0.6,
                  fontSize: "13px",
                  p: 1.2,
                  backgroundColor: "neutral.grey",
                  border: "2px solid #90A4AE",
                  "&:hover": {
                    backgroundColor: "#546E7A",
                    border: "2px solid #546E7A",
                  },
                }}
                onClick={() => {
                  setExpandedAllergies(false);
                  setExpandedChiefComplaint(true);
                }}
              >
                Continue
                <ArrowForwardIcon sx={{ width: 15, height: 15 }} />
              </Button> */}
                </Box>
              </AccordionDetails>
            </Accordion>

            {/* Past Medical History Accordion */}
            <Accordion
              expanded={expandedPastMedical}
              onChange={(e, isExpanded) => setExpandedPastMedical(isExpanded)}
              sx={{
                width: "100%",
                mt: 2,
                borderRadius: "10px",
                boxShadow: "none",
                border: "1px solid #E1E1E1",
                overflow: "hidden",
                "&:before": { display: "none" },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  backgroundColor: "neutral.white",
                  borderRadius: "16px",
                  minHeight: "52px",
                  "& .MuiAccordionSummary-content": {
                    alignItems: "center",
                    margin: "12px 0",
                  },
                  "& .MuiAccordionSummary-expandIconWrapper": {
                    alignSelf: "center",
                  },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      backgroundColor: "neutral.blackBorder",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <HistoryOutlinedIcon sx={{ color: "#0097B2" }} />
                  </Box>
                  <Typography fontWeight={600}>Past Medical History</Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails sx={{ p: 2 }}>
                {/* No Past Medical History checkbox */}
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}
                >
                  <Checkbox
                    checked={noPastMedical === "no_past_medical_history"}
                    onChange={(e) => {
                      setNoPastMedical(
                        e.target.checked ? "no_past_medical_history" : false,
                      );
                    }}
                    size="small"
                    sx={{
                      p: 0,
                      color: "#0097B2",
                      "&.Mui-checked": { color: "#0097B2" },
                    }}
                  />
                  <Typography
                    sx={{ fontSize: "13px", fontWeight: 600, color: "#333" }}
                  >
                    No Past Medical History
                  </Typography>
                </Box>

                {/* Disease checkboxes — chip style */}
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "6px",
                    opacity: noPastMedical ? 0.4 : 1,
                    pointerEvents: noPastMedical ? "none" : "auto",
                    mb: 2,
                  }}
                >
                  {PAST_MEDICAL_CONDITIONS.map((condition) => {
                    const selected = pastMedicalSelected.includes(condition);
                    return (
                      <Box
                        key={condition}
                        onClick={() => togglePastMedical(condition)}
                        sx={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 0.5,
                          px: 1.2,
                          py: 0.5,
                          borderRadius: "20px",
                          cursor: "pointer",
                          border: selected
                            ? "1.5px solid #0097B2"
                            : "1.5px solid #D0D8DA",
                          backgroundColor: selected ? "#E6F7FA" : "#FAFCFC",
                          transition: "all 0.15s",
                          "&:hover": {
                            borderColor: "#0097B2",
                            backgroundColor: "#F0FAFB",
                          },
                        }}
                      >
                        <Checkbox
                          checked={selected}
                          onChange={() => togglePastMedical(condition)}
                          size="small"
                          onClick={(e) => e.stopPropagation()}
                          sx={{
                            p: 0,
                            color: "#0097B2",
                            "&.Mui-checked": { color: "#0097B2" },
                            width: 14,
                            height: 14,
                          }}
                        />
                        <Typography
                          sx={{
                            fontSize: "11px",
                            color: selected ? "#0097B2" : "#555",
                            fontWeight: selected ? 600 : 400,
                            userSelect: "none",
                          }}
                        >
                          {condition}
                        </Typography>
                      </Box>
                    );
                  })}
                </Box>

                {/* Comments */}
                <Box sx={{ mb: 2 }}>
                  <label style={labelStyle}>Comments</label>
                  <textarea
                    value={pastMedicalComments}
                    onChange={(e) => setPastMedicalComments(e.target.value)}
                    rows={3}
                    style={{
                      ...fieldBase,
                      height: "auto",
                      resize: "vertical",
                      padding: "6px",
                    }}
                    placeholder="Add any additional comments..."
                  />
                </Box>

                {/* Buttons */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 1,
                    mt: 1,
                    flexWrap: "wrap",
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      ...primaryBtnTeal,
                      gap: 0.6,
                      fontSize: "13px",
                      p: 1.2,
                    }}
                    onClick={savePastMedical}
                  >
                    <SaveIcon sx={{ width: 15, height: 15 }} />
                    Save
                  </Button>
                  {/* <Button
                variant="contained"
                sx={{ ...primaryBtnTeal, gap: 0.6, fontSize: "13px", p: 1.2 }}
                onClick={savePastMedical}
              >
                <SaveIcon sx={{ width: 15, height: 15 }} />
                <ArrowForwardIcon sx={{ width: 14, height: 14 }} />
                Save & Continue
              </Button> */}
                  {/* <Button
                variant="contained"
                sx={{
                  ...primaryBtnTeal,
                  gap: 0.6,
                  fontSize: "13px",
                  p: 1.2,
                  backgroundColor: "neutral.grey",
                  border: "2px solid #90A4AE",
                  "&:hover": {
                    backgroundColor: "#546E7A",
                    border: "2px solid #546E7A",
                  },
                }}
              >
                Continue
                <ArrowForwardIcon sx={{ width: 15, height: 15 }} />
              </Button> */}
                </Box>
              </AccordionDetails>
            </Accordion>

            {/* Past Surgical History Accordion */}
            <Accordion
              expanded={expandedPastSurgical}
              onChange={(e, isExpanded) => setExpandedPastSurgical(isExpanded)}
              sx={{
                width: "100%",
                mt: 2,
                borderRadius: "10px",
                boxShadow: "none",
                border: "1px solid #E1E1E1",
                overflow: "hidden",
                "&:before": { display: "none" },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  backgroundColor: "neutral.white",
                  borderRadius: "16px",
                  minHeight: "52px",
                  "& .MuiAccordionSummary-content": {
                    alignItems: "center",
                    margin: "12px 0",
                  },
                  "& .MuiAccordionSummary-expandIconWrapper": {
                    alignSelf: "center",
                  },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      backgroundColor: "neutral.blackBorder",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <ContentCutOutlinedIcon sx={{ color: "#0097B2" }} />
                  </Box>
                  <Typography fontWeight={600}>
                    Past Surgical History
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails sx={{ p: 2 }}>
                {/* Women - Operations heading */}
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: 700,
                    color: "#444",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    mb: 1.5,
                    textAlign: "center",
                  }}
                >
                  Women — Operations
                </Typography>

                {/* No Past Surgical History checkbox */}
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}
                >
                  <Checkbox
                    checked={noPastSurgical === "no_past_surgical_history"}
                    onChange={(e) => {
                      setNoPastSurgical(
                        e.target.checked ? "no_past_surgical_history" : false,
                      );
                    }}
                    size="small"
                    sx={{
                      p: 0,
                      color: "#0097B2",
                      "&.Mui-checked": { color: "#0097B2" },
                    }}
                  />
                  <Typography
                    sx={{ fontSize: "13px", fontWeight: 600, color: "#333" }}
                  >
                    No Past Surgical History
                  </Typography>
                </Box>

                {/* Surgery condition chips */}
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "6px",
                    mb: 2,
                    opacity:
                      noPastSurgical === "no_past_surgical_history" ? 0.4 : 1,
                    pointerEvents:
                      noPastSurgical === "no_past_surgical_history"
                        ? "none"
                        : "auto",
                  }}
                >
                  {PAST_SURGICAL_CONDITIONS.map((condition) => {
                    const isSelected = surgicalRows.some(
                      (r) => r.fromChip && r.procedure === condition,
                    );
                    return (
                      <Box
                        key={condition}
                        onClick={() => addSurgicalProcedureFromChip(condition)}
                        sx={{
                          display: "inline-flex",
                          alignItems: "center",
                          px: 1.2,
                          py: 0.5,
                          borderRadius: "20px",
                          cursor: "pointer",
                          border: isSelected
                            ? "1.5px solid #0097B2"
                            : "1.5px solid #D0D8DA",
                          backgroundColor: isSelected ? "#E6F7FA" : "#FAFCFC",
                          transition: "all 0.15s",
                          "&:hover": {
                            borderColor: "#0097B2",
                            backgroundColor: "#F0FAFB",
                          },
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "11px",
                            color: isSelected ? "#0097B2" : "#555",
                            fontWeight: isSelected ? 600 : 400,
                            userSelect: "none",
                          }}
                        >
                          {condition}
                        </Typography>
                      </Box>
                    );
                  })}
                </Box>

                {/* Surgery table */}
                <TableContainer
                  sx={{
                    border: "1px solid #E1E1E1",
                    borderRadius: "8px",
                    mb: 1,
                    opacity:
                      noPastSurgical === "no_past_surgical_history" ? 0.4 : 1,
                    pointerEvents:
                      noPastSurgical === "no_past_surgical_history"
                        ? "none"
                        : "auto",
                  }}
                >
                  <Table size="small" sx={{ tableLayout: "fixed" }}>
                    <colgroup>
                      <col style={{ width: "24%" }} />
                      <col style={{ width: "21%" }} />
                      <col style={{ width: "24%" }} />
                      <col style={{ width: "30%" }} />
                    </colgroup>
                    <TableHead>
                      <TableRow sx={{ backgroundColor: "#F5F7F8" }}>
                        {["Procedure", "Body Site", "Findings", "Date"].map(
                          (h, i) => (
                            <TableCell
                              key={h}
                              sx={{
                                fontSize: "10px",
                                fontWeight: 700,
                                color: "#666",
                                textTransform: "uppercase",
                                py: "7px",
                                whiteSpace: "nowrap",
                                borderRight:
                                  i < 3 ? "1px solid #E1E1E1" : "none",
                              }}
                            >
                              {h}
                            </TableCell>
                          ),
                        )}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {surgicalRows.map((row, i) => (
                        <TableRow key={`surgery-static-${i}`}>
                          <TableCell
                            sx={{ p: "4px", borderRight: "1px solid #E1E1E1" }}
                          >
                            <input
                              style={{
                                ...fieldBase,
                                fontSize: "11px",
                                height: "28px",
                              }}
                              value={row.procedure}
                              onChange={(e) => {
                                const val = e.target.value;
                                updateSurgicalRow(i, "procedure", val);
                              }}
                            />
                          </TableCell>
                          <TableCell
                            sx={{ p: "4px", borderRight: "1px solid #E1E1E1" }}
                          >
                            <input
                              style={{
                                ...fieldBase,
                                fontSize: "11px",
                                height: "28px",
                              }}
                              value={row.body_site}
                              onChange={(e) =>
                                updateSurgicalRow(
                                  i,
                                  "body_site",
                                  e.target.value,
                                )
                              }
                            />
                          </TableCell>
                          <TableCell
                            sx={{ p: "4px", borderRight: "1px solid #E1E1E1" }}
                          >
                            <textarea
                              style={{
                                ...fieldBase,
                                height: "28px",
                                resize: "none",
                                fontSize: "11px",
                                padding: "4px 6px",
                                lineHeight: "1.2",
                              }}
                              value={row.findings}
                              onChange={(e) =>
                                updateSurgicalRow(i, "findings", e.target.value)
                              }
                            />
                          </TableCell>
                          <TableCell sx={{ p: "4px" }}>
                            <input
                              type="date"
                              style={{
                                ...fieldBase,
                                fontSize: "11px",
                                height: "28px",
                              }}
                              value={row.date}
                              onChange={(e) =>
                                updateSurgicalRow(i, "date", e.target.value)
                              }
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                {/* More / Less toggle */}
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}
                >
                  <Box
                    onClick={() => setShowMoreSurgeries((prev) => !prev)}
                    sx={{
                      fontSize: "11px",
                      fontWeight: 600,
                      color: "#0097B2",
                      cursor: "pointer",
                      textDecoration: "underline",
                      userSelect: "none",
                    }}
                  >
                    {showMoreSurgeries ? "Less" : "More"}
                  </Box>
                </Box>

                {/* More Surgeries section */}
                {showMoreSurgeries && (
                  <Box sx={{ mb: 2 }}>
                    <Typography
                      sx={{
                        fontSize: "11px",
                        fontWeight: 700,
                        color: "#666",
                        textTransform: "uppercase",
                        mb: 1,
                      }}
                    >
                      More Surgeries
                    </Typography>
                    <TableContainer
                      sx={{ border: "1px solid #E1E1E1", borderRadius: "8px" }}
                    >
                      <Table size="small" sx={{ tableLayout: "fixed" }}>
                        <colgroup>
                          <col style={{ width: "24%" }} />
                          <col style={{ width: "18%" }} />
                          <col style={{ width: "24%" }} />
                          <col style={{ width: "34%" }} />
                        </colgroup>
                        <TableHead>
                          <TableRow sx={{ backgroundColor: "#F5F7F8" }}>
                            {["Procedure", "Body Site", "Findings", "Date"].map(
                              (h, i) => (
                                <TableCell
                                  key={h}
                                  sx={{
                                    fontSize: "10px",
                                    fontWeight: 700,
                                    color: "#666",
                                    textTransform: "uppercase",
                                    py: "7px",
                                    whiteSpace: "nowrap",
                                    borderRight:
                                      i < 3 ? "1px solid #E1E1E1" : "none",
                                  }}
                                >
                                  {h}
                                </TableCell>
                              ),
                            )}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {surgicalMoreRows.map((row, i) => (
                            <TableRow key={`surgery-more-${i}`}>
                              <TableCell
                                sx={{
                                  p: "4px",
                                  borderRight: "1px solid #E1E1E1",
                                }}
                              >
                                <input
                                  style={{
                                    ...fieldBase,
                                    fontSize: "11px",
                                    height: "28px",
                                  }}
                                  value={row.procedure}
                                  onChange={(e) =>
                                    updateSurgicalMoreRow(
                                      i,
                                      "procedure",
                                      e.target.value,
                                    )
                                  }
                                />
                              </TableCell>
                              <TableCell
                                sx={{
                                  p: "4px",
                                  borderRight: "1px solid #E1E1E1",
                                }}
                              >
                                <input
                                  style={{
                                    ...fieldBase,
                                    fontSize: "11px",
                                    height: "28px",
                                  }}
                                  value={row.body_site}
                                  onChange={(e) =>
                                    updateSurgicalMoreRow(
                                      i,
                                      "body_site",
                                      e.target.value,
                                    )
                                  }
                                />
                              </TableCell>
                              <TableCell
                                sx={{
                                  p: "4px",
                                  borderRight: "1px solid #E1E1E1",
                                }}
                              >
                                <textarea
                                  style={{
                                    ...fieldBase,
                                    height: "28px",
                                    resize: "none",
                                    fontSize: "11px",
                                    padding: "4px 6px",
                                    lineHeight: "1.2",
                                  }}
                                  value={row.findings}
                                  onChange={(e) =>
                                    updateSurgicalMoreRow(
                                      i,
                                      "findings",
                                      e.target.value,
                                    )
                                  }
                                />
                              </TableCell>
                              <TableCell sx={{ p: "4px" }}>
                                <input
                                  type="date"
                                  style={{
                                    ...fieldBase,
                                    fontSize: "11px",
                                    height: "28px",
                                  }}
                                  value={row.date}
                                  onChange={(e) =>
                                    updateSurgicalMoreRow(
                                      i,
                                      "date",
                                      e.target.value,
                                    )
                                  }
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                )}

                {/* Buttons */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 1,
                    mt: 1,
                    flexWrap: "wrap",
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      ...primaryBtnTeal,
                      gap: 0.6,
                      fontSize: "13px",
                      p: 1.2,
                    }}
                    onClick={savePastSurgical}
                  >
                    <SaveIcon sx={{ width: 15, height: 15 }} />
                    Save
                  </Button>
                  {/* <Button
                variant="contained"
                sx={{ ...primaryBtnTeal, gap: 0.6, fontSize: "13px", p: 1.2 }}
                onClick={savePastSurgical}
              >
                <SaveIcon sx={{ width: 15, height: 15 }} />
                <ArrowForwardIcon sx={{ width: 14, height: 14 }} />
                Save & Continue
              </Button> */}
                  {/* <Button
                variant="contained"
                sx={{
                  ...primaryBtnTeal,
                  gap: 0.6,
                  fontSize: "13px",
                  p: 1.2,
                  backgroundColor: "neutral.grey",
                  border: "2px solid #90A4AE",
                  "&:hover": {
                    backgroundColor: "#546E7A",
                    border: "2px solid #546E7A",
                  },
                }}
              >
                Continue
                <ArrowForwardIcon sx={{ width: 15, height: 15 }} />
              </Button> */}
                </Box>
              </AccordionDetails>
            </Accordion>

            {/* Past Diagnostic History Accordion */}
            <Accordion
              expanded={expandedPastDiagnostic}
              onChange={(e, isExpanded) =>
                setExpandedPastDiagnostic(isExpanded)
              }
              sx={{
                width: "100%",
                mt: 2,
                borderRadius: "10px",
                boxShadow: "none",
                border: "1px solid #E1E1E1",
                overflow: "hidden",
                "&:before": { display: "none" },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  backgroundColor: "neutral.white",
                  borderRadius: "16px",
                  minHeight: "52px",
                  "& .MuiAccordionSummary-content": {
                    alignItems: "center",
                    margin: "12px 0",
                  },
                  "& .MuiAccordionSummary-expandIconWrapper": {
                    alignSelf: "center",
                  },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      backgroundColor: "neutral.blackBorder",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <ReportProblemOutlinedIcon sx={{ color: "#0097B2" }} />
                  </Box>
                  <Typography fontWeight={600}>
                    Past Diagnostic History
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails sx={{ p: 2 }}>
                {/* No Past Diagnostic History checkbox */}
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}
                >
                  <Checkbox
                    checked={noPastDiagnostic === "no_past_diagnostic_history"}
                    onChange={(e) => {
                      setNoPastDiagnostic(
                        e.target.checked ? "no_past_diagnostic_history" : false,
                      );
                    }}
                    size="small"
                    sx={{
                      p: 0,
                      color: "#0097B2",
                      "&.Mui-checked": { color: "#0097B2" },
                    }}
                  />
                  <Typography
                    sx={{ fontSize: "13px", fontWeight: 600, color: "#333" }}
                  >
                    No Past Diagnostic History
                  </Typography>
                </Box>

                {/* Diagnostic condition chips */}
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "6px",
                    mb: 2,
                    opacity:
                      noPastDiagnostic === "no_past_diagnostic_history"
                        ? 0.4
                        : 1,
                    pointerEvents:
                      noPastDiagnostic === "no_past_diagnostic_history"
                        ? "none"
                        : "auto",
                  }}
                >
                  {PAST_DIAGNOSTIC_CONDITIONS.map((condition) => {
                    const isSelected = diagnosticRows.some(
                      (r) => r.fromChip && r.procedure === condition,
                    );
                    return (
                      <Box
                        key={condition}
                        onClick={() =>
                          addDiagnosticProcedureFromChip(condition)
                        }
                        sx={{
                          display: "inline-flex",
                          alignItems: "center",
                          px: 1.2,
                          py: 0.5,
                          borderRadius: "20px",
                          cursor: "pointer",
                          border: isSelected
                            ? "1.5px solid #0097B2"
                            : "1.5px solid #D0D8DA",
                          backgroundColor: isSelected ? "#E6F7FA" : "#FAFCFC",
                          transition: "all 0.15s",
                          "&:hover": {
                            borderColor: "#0097B2",
                            backgroundColor: "#F0FAFB",
                          },
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "11px",
                            color: isSelected ? "#0097B2" : "#555",
                            fontWeight: isSelected ? 600 : 400,
                            userSelect: "none",
                          }}
                        >
                          {condition}
                        </Typography>
                      </Box>
                    );
                  })}
                </Box>

                {/* Diagnostic table */}
                <TableContainer
                  sx={{
                    border: "1px solid #E1E1E1",
                    borderRadius: "8px",
                    mb: 1,
                    opacity:
                      noPastDiagnostic === "no_past_diagnostic_history"
                        ? 0.4
                        : 1,
                    pointerEvents:
                      noPastDiagnostic === "no_past_diagnostic_history"
                        ? "none"
                        : "auto",
                  }}
                >
                  <Table size="small" sx={{ tableLayout: "fixed" }}>
                    <colgroup>
                      <col style={{ width: "24%" }} />
                      <col style={{ width: "21%" }} />
                      <col style={{ width: "24%" }} />
                      <col style={{ width: "30%" }} />
                    </colgroup>
                    <TableHead>
                      <TableRow sx={{ backgroundColor: "#F5F7F8" }}>
                        {["Procedure", "Body Site", "Findings", "Date"].map(
                          (h, i) => (
                            <TableCell
                              key={h}
                              sx={{
                                fontSize: "10px",
                                fontWeight: 700,
                                color: "#666",
                                textTransform: "uppercase",
                                py: "7px",
                                whiteSpace: "nowrap",
                                borderRight:
                                  i < 3 ? "1px solid #E1E1E1" : "none",
                              }}
                            >
                              {h}
                            </TableCell>
                          ),
                        )}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {diagnosticRows.map((row, i) => (
                        <TableRow key={`diag-static-${i}`}>
                          <TableCell
                            sx={{ p: "4px", borderRight: "1px solid #E1E1E1" }}
                          >
                            <input
                              value={row.procedure}
                              onChange={(e) =>
                                updateDiagnosticRow(
                                  i,
                                  "procedure",
                                  e.target.value,
                                )
                              }
                              style={{
                                ...fieldBase,
                                fontSize: "11px",
                                height: "28px",
                              }}
                            />
                          </TableCell>
                          <TableCell
                            sx={{ p: "4px", borderRight: "1px solid #E1E1E1" }}
                          >
                            <input
                              value={row.body_site}
                              onChange={(e) =>
                                updateDiagnosticRow(
                                  i,
                                  "body_site",
                                  e.target.value,
                                )
                              }
                              style={{
                                ...fieldBase,
                                fontSize: "11px",
                                height: "28px",
                              }}
                            />
                          </TableCell>
                          <TableCell
                            sx={{ p: "4px", borderRight: "1px solid #E1E1E1" }}
                          >
                            <textarea
                              value={row.findings}
                              onChange={(e) =>
                                updateDiagnosticRow(
                                  i,
                                  "findings",
                                  e.target.value,
                                )
                              }
                              style={{
                                ...fieldBase,
                                height: "28px",
                                resize: "none",
                                fontSize: "11px",
                                padding: "4px 6px",
                                lineHeight: "1.2",
                              }}
                            />
                          </TableCell>
                          <TableCell sx={{ p: "4px" }}>
                            <input
                              type="date"
                              value={row.date}
                              onChange={(e) =>
                                updateDiagnosticRow(i, "date", e.target.value)
                              }
                              style={{
                                ...fieldBase,
                                fontSize: "11px",
                                height: "28px",
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                {/* More / Less toggle */}
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}
                >
                  <Box
                    onClick={() => setShowMoreDiagnostic((prev) => !prev)}
                    sx={{
                      fontSize: "11px",
                      fontWeight: 600,
                      color: "#0097B2",
                      cursor: "pointer",
                      textDecoration: "underline",
                      userSelect: "none",
                    }}
                  >
                    {showMoreDiagnostic ? "Less" : "More"}
                  </Box>
                </Box>

                {/* More Diagnostic rows */}
                {showMoreDiagnostic && (
                  <Box sx={{ mb: 2 }}>
                    <TableContainer
                      sx={{ border: "1px solid #E1E1E1", borderRadius: "8px" }}
                    >
                      <Table size="small" sx={{ tableLayout: "fixed" }}>
                        <colgroup>
                          <col style={{ width: "24%" }} />
                          <col style={{ width: "18%" }} />
                          <col style={{ width: "24%" }} />
                          <col style={{ width: "34%" }} />
                        </colgroup>
                        <TableHead>
                          <TableRow sx={{ backgroundColor: "#F5F7F8" }}>
                            {["Procedure", "Body Site", "Findings", "Date"].map(
                              (h, i) => (
                                <TableCell
                                  key={h}
                                  sx={{
                                    fontSize: "10px",
                                    fontWeight: 700,
                                    color: "#666",
                                    textTransform: "uppercase",
                                    py: "7px",
                                    whiteSpace: "nowrap",
                                    borderRight:
                                      i < 3 ? "1px solid #E1E1E1" : "none",
                                  }}
                                >
                                  {h}
                                </TableCell>
                              ),
                            )}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {diagnosticMoreRows.map((row, i) => (
                            <TableRow key={`diag-more-${i}`}>
                              <TableCell
                                sx={{
                                  p: "4px",
                                  borderRight: "1px solid #E1E1E1",
                                }}
                              >
                                <input
                                  value={row.procedure}
                                  onChange={(e) =>
                                    updateDiagnosticMoreRow(
                                      i,
                                      "procedure",
                                      e.target.value,
                                    )
                                  }
                                  style={{
                                    ...fieldBase,
                                    fontSize: "11px",
                                    height: "28px",
                                  }}
                                />
                              </TableCell>
                              <TableCell
                                sx={{
                                  p: "4px",
                                  borderRight: "1px solid #E1E1E1",
                                }}
                              >
                                <input
                                  value={row.body_site}
                                  onChange={(e) =>
                                    updateDiagnosticMoreRow(
                                      i,
                                      "body_site",
                                      e.target.value,
                                    )
                                  }
                                  style={{
                                    ...fieldBase,
                                    fontSize: "11px",
                                    height: "28px",
                                  }}
                                />
                              </TableCell>
                              <TableCell
                                sx={{
                                  p: "4px",
                                  borderRight: "1px solid #E1E1E1",
                                }}
                              >
                                <textarea
                                  value={row.findings}
                                  onChange={(e) =>
                                    updateDiagnosticMoreRow(
                                      i,
                                      "findings",
                                      e.target.value,
                                    )
                                  }
                                  style={{
                                    ...fieldBase,
                                    height: "28px",
                                    resize: "none",
                                    fontSize: "11px",
                                    padding: "4px 6px",
                                    lineHeight: "1.2",
                                  }}
                                />
                              </TableCell>
                              <TableCell sx={{ p: "4px" }}>
                                <input
                                  type="date"
                                  value={row.date}
                                  onChange={(e) =>
                                    updateDiagnosticMoreRow(
                                      i,
                                      "date",
                                      e.target.value,
                                    )
                                  }
                                  style={{
                                    ...fieldBase,
                                    fontSize: "11px",
                                    height: "28px",
                                  }}
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                )}

                {/* Buttons */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 1,
                    mt: 1,
                    flexWrap: "wrap",
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      ...primaryBtnTeal,
                      gap: 0.6,
                      fontSize: "13px",
                      p: 1.2,
                    }}
                    onClick={savePastDiagnostic}
                  >
                    <SaveIcon sx={{ width: 15, height: 15 }} /> Save
                  </Button>
                  {/* <Button
                variant="contained"
                sx={{ ...primaryBtnTeal, gap: 0.6, fontSize: "13px", p: 1.2 }}
                onClick={savePastDiagnostic}
              >
                <SaveIcon sx={{ width: 15, height: 15 }} />
                <ArrowForwardIcon sx={{ width: 14, height: 14 }} />
                Save & Continue
              </Button> */}
                  {/* <Button
                variant="contained"
                sx={{
                  ...primaryBtnTeal,
                  gap: 0.6,
                  fontSize: "13px",
                  p: 1.2,
                  backgroundColor: "neutral.grey",
                  border: "2px solid #90A4AE",
                  "&:hover": {
                    backgroundColor: "#546E7A",
                    border: "2px solid #546E7A",
                  },
                }}
              >
                Continue <ArrowForwardIcon sx={{ width: 15, height: 15 }} />
              </Button> */}
                </Box>
              </AccordionDetails>
            </Accordion>

            {/* Gyn History Accordion */}
            <Accordion
              expanded={expandedGynHistory}
              onChange={(e, isExpanded) => setExpandedGynHistory(isExpanded)}
              sx={{
                width: "100%",
                mt: 2,
                borderRadius: "10px",
                boxShadow: "none",
                border: "1px solid #E1E1E1",
                overflow: "hidden",
                "&:before": { display: "none" },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  backgroundColor: "neutral.white",
                  minHeight: "52px",
                  "& .MuiAccordionSummary-content": {
                    alignItems: "center",
                    margin: "12px 0",
                  },
                  "& .MuiAccordionSummary-expandIconWrapper": {
                    alignSelf: "center",
                  },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      backgroundColor: "neutral.blackBorder",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <HistoryOutlinedIcon sx={{ color: "#0097B2" }} />
                  </Box>
                  <Typography fontWeight={600}>Gyn History</Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails sx={{ p: 2 }}>
                {/* ── LMP / Hysterectomy / Menopause radio group ── */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                    mb: 2,
                  }}
                >
                  {[
                    { value: "lmp", label: "LMP" },
                    { value: "hysterectomy", label: "Hysterectomy" },
                    { value: "menopause", label: "Menopause" },
                  ].map(({ value, label }) => (
                    <Box
                      key={value}
                      sx={{ display: "flex", alignItems: "center", gap: 1 }}
                    >
                      <input
                        type="radio"
                        name="gynLmpRadio"
                        value={value}
                        checked={gynLmpRadio === value}
                        onChange={() => setGynLmpRadio(value)}
                        style={{
                          accentColor: "#0097B2",
                          width: 14,
                          height: 14,
                          cursor: "pointer",
                        }}
                      />
                      <Typography
                        sx={{
                          fontSize: "12px",
                          fontWeight: 500,
                          color: "#333",
                          minWidth: 90,
                        }}
                      >
                        {label}
                      </Typography>
                      <input
                        style={{
                          ...fieldBase,
                          fontSize: "11px",
                          height: "28px",
                          flex: 1,
                          backgroundColor:
                            gynLmpRadio === value ? "white" : "#F3F5F6",
                          color: gynLmpRadio === value ? "#333" : "#aaa",
                          pointerEvents:
                            gynLmpRadio === value ? "auto" : "none",
                        }}
                        disabled={gynLmpRadio !== value}
                        value={
                          value === "lmp"
                            ? gynLmp
                            : value === "hysterectomy"
                              ? gynHysterectomy
                              : gynMenopause
                        }
                        onChange={(e) => {
                          if (value === "lmp") setGynLmp(e.target.value);
                          else if (value === "hysterectomy")
                            setGynHysterectomy(e.target.value);
                          else setGynMenopause(e.target.value);
                        }}
                      />
                    </Box>
                  ))}
                </Box>

                {/* ── Abnormal Pap + Total Pregnancies ── */}
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: 2,
                    mb: 2,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography
                      sx={{
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "#333",
                        minWidth: 100,
                      }}
                    >
                      Abnormal Pap
                    </Typography>
                    <select
                      value={gynAbnormalPap}
                      onChange={(e) => setGynAbnormalPap(e.target.value)}
                      style={{
                        ...fieldBase,
                        fontSize: "11px",
                        height: "28px",
                        flex: 1,
                        cursor: "pointer",
                      }}
                    >
                      <option value=""></option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography
                      sx={{
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "#333",
                        minWidth: 120,
                      }}
                    >
                      Total Pregnancies
                    </Typography>
                    <input
                      style={{
                        ...fieldBase,
                        fontSize: "11px",
                        height: "28px",
                        flex: 1,
                      }}
                      value={gynTotalPregnancies}
                      onChange={(e) => setGynTotalPregnancies(e.target.value)}
                    />
                  </Box>
                </Box>

                {/* Treatment */}
                <Box sx={{ mb: 2 }}>
                  <Box
                    sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}
                  >
                    <Typography
                      sx={{
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "#333",
                        minWidth: 90,
                        mt: "6px",
                      }}
                    >
                      Treatment
                    </Typography>
                    <Box sx={{ flex: 1, position: "relative" }}>
                      <textarea
                        maxLength={200}
                        value={gynTreatment}
                        onChange={(e) => setGynTreatment(e.target.value)}
                        rows={3}
                        style={{
                          ...fieldBase,
                          height: "auto",
                          resize: "none",
                          padding: "6px",
                          fontSize: "11px",
                        }}
                      />
                      <Typography
                        sx={{
                          position: "absolute",
                          bottom: 4,
                          right: 6,
                          fontSize: "10px",
                          color: "#0097B2",
                        }}
                      >
                        {200 - gynTreatment.length}
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                <Divider sx={{ mb: 2 }} />

                {/* ── Menstrual History ── */}
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: 700,
                    color: "#444",
                    textAlign: "center",
                    mb: 1.5,
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                  }}
                >
                  Menstrual History
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                    mb: 2,
                  }}
                >
                  {[
                    {
                      label: "Menarche",
                      value: gynMenarche,
                      setter: setGynMenarche,
                      type: "input",
                    },
                    {
                      label: "Cycle",
                      value: gynCycle,
                      setter: setGynCycle,
                      type: "select",
                      options: ["", "Regular", "Irregular", "Early", "Delayed"],
                    },
                    {
                      label: "Cycle Duration",
                      value: gynCycleDuration,
                      setter: setGynCycleDuration,
                      type: "select",
                      options: [
                        "",
                        "Less than 3 days",
                        "3-7 days",
                        "More than 7 days",
                      ],
                    },
                    {
                      label: "Flow",
                      value: gynFlow,
                      setter: setGynFlow,
                      type: "select",
                      options: ["", "Scanty", "Normal", "Heavy", "None"],
                    },
                    {
                      label: "Cramps",
                      value: gynCramps,
                      setter: setGynCramps,
                      type: "select",
                      options: ["", "None", "Mild", "Moderate", "Severe"],
                    },
                  ].map(({ label, value, setter, type, options }) => (
                    <Box
                      key={label}
                      sx={{ display: "flex", alignItems: "center", gap: 1 }}
                    >
                      <Typography
                        sx={{
                          fontSize: "12px",
                          fontWeight: 500,
                          color: "#333",
                          minWidth: 110,
                        }}
                      >
                        {label}
                      </Typography>
                      {type === "select" ? (
                        <select
                          value={value}
                          onChange={(e) => setter(e.target.value)}
                          style={{
                            ...fieldBase,
                            fontSize: "11px",
                            height: "28px",
                            flex: 1,
                            cursor: "pointer",
                          }}
                        >
                          {options.map((o) => (
                            <option key={o} value={o}>
                              {o}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <input
                          style={{
                            ...fieldBase,
                            fontSize: "11px",
                            height: "28px",
                            flex: 1,
                          }}
                          value={value}
                          onChange={(e) => setter(e.target.value)}
                        />
                      )}
                    </Box>
                  ))}

                  {/* Menstrual Problems textarea */}
                  <Box
                    sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}
                  >
                    <Typography
                      sx={{
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "#333",
                        minWidth: 110,
                        mt: "6px",
                      }}
                    >
                      Menstrual Problems
                    </Typography>
                    <Box sx={{ flex: 1, position: "relative" }}>
                      <textarea
                        maxLength={200}
                        value={gynMenstrualProblems}
                        onChange={(e) =>
                          setGynMenstrualProblems(e.target.value)
                        }
                        rows={3}
                        style={{
                          ...fieldBase,
                          height: "auto",
                          resize: "none",
                          padding: "6px",
                          fontSize: "11px",
                        }}
                      />
                      <Typography
                        sx={{
                          position: "absolute",
                          bottom: 4,
                          right: 6,
                          fontSize: "10px",
                          color: "#0097B2",
                        }}
                      >
                        {200 - gynMenstrualProblems.length}
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                <Divider sx={{ mb: 2 }} />

                {/* ── Birth Control ── */}
                <Box
                  sx={{
                    opacity: gynLmpRadio === "lmp" ? 1 : 0.4,
                    pointerEvents: gynLmpRadio === "lmp" ? "auto" : "none",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: 700,
                      color: "#444",
                      textAlign: "center",
                      mb: 1.5,
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                    }}
                  >
                    Birth Control
                  </Typography>

                  {/* None */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      mb: 1,
                    }}
                  >
                    <Checkbox
                      checked={gynBirthControl.none}
                      onChange={(e) =>
                        setGynBirthControl((p) => ({
                          ...p,
                          none: e.target.checked,
                        }))
                      }
                      size="small"
                      sx={{
                        p: 0,
                        color: "#0097B2",
                        "&.Mui-checked": { color: "#0097B2" },
                      }}
                    />
                    <Typography sx={{ fontSize: "12px", color: "#333" }}>
                      None
                    </Typography>
                  </Box>

                  {/* Grid of birth control options */}
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: "8px 12px",
                      opacity: gynBirthControl.none ? 0.4 : 1,
                      pointerEvents: gynBirthControl.none ? "none" : "auto",
                    }}
                  >
                    {/* Pills */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Checkbox
                        checked={gynBirthControl.pills}
                        onChange={(e) =>
                          setGynBirthControl((p) => ({
                            ...p,
                            pills: e.target.checked,
                          }))
                        }
                        size="small"
                        sx={{
                          p: 0,
                          color: "#0097B2",
                          "&.Mui-checked": { color: "#0097B2" },
                        }}
                      />
                      <Typography
                        sx={{ fontSize: "12px", color: "#333", minWidth: 60 }}
                      >
                        Pills
                      </Typography>
                      {gynBirthControl.pills && (
                        <input
                          style={{
                            ...fieldBase,
                            fontSize: "11px",
                            height: "26px",
                            flex: 1,
                          }}
                          value={gynPillsText}
                          onChange={(e) => setGynPillsText(e.target.value)}
                        />
                      )}
                    </Box>

                    {/* Condoms */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Checkbox
                        checked={gynBirthControl.condoms}
                        onChange={(e) =>
                          setGynBirthControl((p) => ({
                            ...p,
                            condoms: e.target.checked,
                          }))
                        }
                        size="small"
                        sx={{
                          p: 0,
                          color: "#0097B2",
                          "&.Mui-checked": { color: "#0097B2" },
                        }}
                      />
                      <Typography sx={{ fontSize: "12px", color: "#333" }}>
                        Condoms
                      </Typography>
                    </Box>

                    {/* BTL */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Checkbox
                        checked={gynBirthControl.btl}
                        onChange={(e) =>
                          setGynBirthControl((p) => ({
                            ...p,
                            btl: e.target.checked,
                          }))
                        }
                        size="small"
                        sx={{
                          p: 0,
                          color: "#0097B2",
                          "&.Mui-checked": { color: "#0097B2" },
                        }}
                      />
                      <Typography
                        sx={{ fontSize: "12px", color: "#333", minWidth: 60 }}
                      >
                        BTL
                      </Typography>
                      {gynBirthControl.btl && (
                        <input
                          style={{
                            ...fieldBase,
                            fontSize: "11px",
                            height: "26px",
                            flex: 1,
                          }}
                          value={gynBtlText}
                          onChange={(e) => setGynBtlText(e.target.value)}
                        />
                      )}
                    </Box>

                    {/* Contraceptive Ring */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Checkbox
                        checked={gynBirthControl.contraceptiveRing}
                        onChange={(e) =>
                          setGynBirthControl((p) => ({
                            ...p,
                            contraceptiveRing: e.target.checked,
                          }))
                        }
                        size="small"
                        sx={{
                          p: 0,
                          color: "#0097B2",
                          "&.Mui-checked": { color: "#0097B2" },
                        }}
                      />
                      <Typography sx={{ fontSize: "12px", color: "#333" }}>
                        Contraceptive Ring
                      </Typography>
                    </Box>

                    {/* Vasectomy */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Checkbox
                        checked={gynBirthControl.vasectomy}
                        onChange={(e) =>
                          setGynBirthControl((p) => ({
                            ...p,
                            vasectomy: e.target.checked,
                          }))
                        }
                        size="small"
                        sx={{
                          p: 0,
                          color: "#0097B2",
                          "&.Mui-checked": { color: "#0097B2" },
                        }}
                      />
                      <Typography
                        sx={{ fontSize: "12px", color: "#333", minWidth: 60 }}
                      >
                        Vasectomy
                      </Typography>
                      {gynBirthControl.vasectomy && (
                        <input
                          style={{
                            ...fieldBase,
                            fontSize: "11px",
                            height: "26px",
                            flex: 1,
                          }}
                          value={gynVasectomyText}
                          onChange={(e) => setGynVasectomyText(e.target.value)}
                        />
                      )}
                    </Box>

                    {/* Implanon */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Checkbox
                        checked={gynBirthControl.implanon}
                        onChange={(e) =>
                          setGynBirthControl((p) => ({
                            ...p,
                            implanon: e.target.checked,
                          }))
                        }
                        size="small"
                        sx={{
                          p: 0,
                          color: "#0097B2",
                          "&.Mui-checked": { color: "#0097B2" },
                        }}
                      />
                      <Typography
                        sx={{ fontSize: "12px", color: "#333", minWidth: 60 }}
                      >
                        Implanon
                      </Typography>
                      {gynBirthControl.implanon && (
                        <input
                          style={{
                            ...fieldBase,
                            fontSize: "11px",
                            height: "26px",
                            flex: 1,
                          }}
                          value={gynImplanonText}
                          onChange={(e) => setGynImplanonText(e.target.value)}
                        />
                      )}
                    </Box>

                    {/* Attempting Pregnancy */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Checkbox
                        checked={gynBirthControl.attemptingPregnancy}
                        onChange={(e) =>
                          setGynBirthControl((p) => ({
                            ...p,
                            attemptingPregnancy: e.target.checked,
                          }))
                        }
                        size="small"
                        sx={{
                          p: 0,
                          color: "#0097B2",
                          "&.Mui-checked": { color: "#0097B2" },
                        }}
                      />
                      <Typography sx={{ fontSize: "12px", color: "#333" }}>
                        Attempting Pregnancy
                      </Typography>
                    </Box>

                    {/* Others */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Checkbox
                        checked={gynBirthControl.others}
                        onChange={(e) =>
                          setGynBirthControl((p) => ({
                            ...p,
                            others: e.target.checked,
                          }))
                        }
                        size="small"
                        sx={{
                          p: 0,
                          color: "#0097B2",
                          "&.Mui-checked": { color: "#0097B2" },
                        }}
                      />
                      <Typography
                        sx={{ fontSize: "12px", color: "#333", minWidth: 60 }}
                      >
                        Others
                      </Typography>
                      {gynBirthControl.others && (
                        <input
                          style={{
                            ...fieldBase,
                            fontSize: "11px",
                            height: "26px",
                            flex: 1,
                          }}
                          value={gynOthersText}
                          onChange={(e) => setGynOthersText(e.target.value)}
                        />
                      )}
                    </Box>

                    {/* IUD — spans full width, shows type + insert/removal dates */}
                    <Box
                      sx={{
                        gridColumn: "1 / -1",
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        flexWrap: "wrap",
                      }}
                    >
                      <Checkbox
                        checked={gynBirthControl.iud}
                        onChange={(e) =>
                          setGynBirthControl((p) => ({
                            ...p,
                            iud: e.target.checked,
                          }))
                        }
                        size="small"
                        sx={{
                          p: 0,
                          color: "#0097B2",
                          "&.Mui-checked": { color: "#0097B2" },
                        }}
                      />
                      <Typography
                        sx={{ fontSize: "12px", color: "#333", minWidth: 40 }}
                      >
                        IUD
                      </Typography>
                      {gynBirthControl.iud && (
                        <>
                          <select
                            value={gynIudType}
                            onChange={(e) => setGynIudType(e.target.value)}
                            style={{
                              ...fieldBase,
                              fontSize: "11px",
                              height: "26px",
                              width: 110,
                              cursor: "pointer",
                            }}
                          >
                            <option value=""></option>
                            <option value="ParaGard">ParaGard</option>
                            <option value="Mirena">Mirena</option>
                            <option value="Kyleena">Kyleena</option>
                            <option value="Skyla">Skyla</option>
                          </select>
                          <Typography
                            sx={{ fontSize: "11px", color: "#666", ml: 1 }}
                          >
                            Insert Date
                          </Typography>
                          <input
                            type="date"
                            style={{
                              ...fieldBase,
                              fontSize: "11px",
                              height: "26px",
                              width: 130,
                            }}
                            value={gynIudInsertDate}
                            onChange={(e) =>
                              setGynIudInsertDate(e.target.value)
                            }
                          />
                          <Typography
                            sx={{ fontSize: "11px", color: "#666", ml: 1 }}
                          >
                            Removal Date
                          </Typography>
                          <input
                            type="date"
                            style={{
                              ...fieldBase,
                              fontSize: "11px",
                              height: "26px",
                              width: 130,
                            }}
                            value={gynIudRemovalDate}
                            onChange={(e) =>
                              setGynIudRemovalDate(e.target.value)
                            }
                          />
                        </>
                      )}
                    </Box>
                  </Box>
                </Box>
                {/* end Birth Control disable wrapper */}

                {/* Buttons */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 1,
                    mt: 2,
                    flexWrap: "wrap",
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      ...primaryBtnTeal,
                      gap: 0.6,
                      fontSize: "13px",
                      p: 1.2,
                    }}
                    onClick={saveGynHistory}
                  >
                    <SaveIcon sx={{ width: 15, height: 15 }} /> Save
                  </Button>
                  {/* <Button
                variant="contained"
                sx={{ ...primaryBtnTeal, gap: 0.6, fontSize: "13px", p: 1.2 }}
                onClick={saveGynHistory}
              >
                <SaveIcon sx={{ width: 15, height: 15 }} />
                <ArrowForwardIcon sx={{ width: 14, height: 14 }} />
                Save & Continue
              </Button> */}
                  {/* <Button
                variant="contained"
                sx={{
                  ...primaryBtnTeal,
                  gap: 0.6,
                  fontSize: "13px",
                  p: 1.2,
                  backgroundColor: "neutral.grey",
                  border: "2px solid #90A4AE",
                  "&:hover": {
                    backgroundColor: "#546E7A",
                    border: "2px solid #546E7A",
                  },
                }}
              >
                Continue <ArrowForwardIcon sx={{ width: 15, height: 15 }} />
              </Button> */}
                </Box>
              </AccordionDetails>
            </Accordion>

            {/* Past Pregnancies Accordion */}
            <Accordion
              expanded={expandedPastPregnancies}
              onChange={(e, isExpanded) =>
                setExpandedPastPregnancies(isExpanded)
              }
              sx={{
                width: "100%",
                mt: 2,
                borderRadius: "10px",
                boxShadow: "none",
                border: "1px solid #E1E1E1",
                overflow: "hidden",
                "&:before": { display: "none" },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  backgroundColor: "neutral.white",
                  minHeight: "52px",
                  "& .MuiAccordionSummary-content": {
                    alignItems: "center",
                    margin: "12px 0",
                  },
                  "& .MuiAccordionSummary-expandIconWrapper": {
                    alignSelf: "center",
                  },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      backgroundColor: "neutral.blackBorder",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <HistoryOutlinedIcon sx={{ color: "#0097B2" }} />
                  </Box>
                  <Typography fontWeight={600}>Past Pregnancies</Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails sx={{ p: 2 }}>
                {/* More rows selector */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: 1,
                    mb: 1,
                  }}
                >
                  <Typography sx={{ fontSize: "11px", color: "#666" }}>
                    More
                  </Typography>
                  <select
                    value={pregnancyMoreRows}
                    onChange={(e) =>
                      setPregnancyMoreRows(Number(e.target.value))
                    }
                    style={{
                      ...fieldBase,
                      width: 70,
                      height: "28px",
                      fontSize: "11px",
                      cursor: "pointer",
                    }}
                  >
                    <option value={0}>—</option>
                    {[1, 2, 3, 4, 5].map((n) => (
                      <option key={n} value={n}>
                        {n}
                      </option>
                    ))}
                  </select>
                </Box>

                {/* Pregnancy rows — card layout */}
                {Array.from({ length: 5 + pregnancyMoreRows }, (_, i) => (
                  <Box
                    key={`preg-${i}`}
                    sx={{
                      border: "1px solid #E1E1E1",
                      borderRadius: "8px",
                      p: 1,
                      mb: 1,
                      backgroundColor: "#fafcfc",
                    }}
                  >
                    {/* Row 1: Date | GA Weeks | Birth Weight | Type of Delivery */}
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: 1,
                        mb: 1,
                      }}
                    >
                      <Box>
                        <span style={labelStyle}>Date</span>
                        <input
                          type="date"
                          value={pregnancyRows[i].date}
                          onChange={(e) =>
                            updatePregnancyRow(i, "date", e.target.value)
                          }
                          style={{
                            ...fieldBase,
                            fontSize: "11px",
                            height: "28px",
                          }}
                        />
                      </Box>
                      <Box>
                        <span style={labelStyle}>GA Weeks</span>
                        <input
                          value={pregnancyRows[i].ga_weeks}
                          onChange={(e) =>
                            updatePregnancyRow(i, "ga_weeks", e.target.value)
                          }
                          style={{
                            ...fieldBase,
                            fontSize: "11px",
                            height: "28px",
                          }}
                        />
                      </Box>
                      <Box>
                        <span style={labelStyle}>Birth Weight</span>
                        <input
                          value={pregnancyRows[i].birth_weight}
                          onChange={(e) =>
                            updatePregnancyRow(
                              i,
                              "birth_weight",
                              e.target.value,
                            )
                          }
                          style={{
                            ...fieldBase,
                            fontSize: "11px",
                            height: "28px",
                          }}
                        />
                      </Box>
                      <Box>
                        <span style={labelStyle}>Type of Delivery</span>
                        <select
                          value={pregnancyRows[i].type_of_delivery}
                          onChange={(e) =>
                            updatePregnancyRow(
                              i,
                              "type_of_delivery",
                              e.target.value,
                            )
                          }
                          style={{
                            ...fieldBase,
                            fontSize: "11px",
                            height: "28px",
                            cursor: "pointer",
                          }}
                        >
                          <option value=""></option>
                          <option>Normal</option>
                          <option>C-Section</option>
                          <option>Forceps</option>
                          <option>Vacuum</option>
                        </select>
                      </Box>
                    </Box>
                    {/* Row 2: Place of Delivery | Preterm Labor | Outcome | Comments */}
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: 1,
                      }}
                    >
                      <Box>
                        <span style={labelStyle}>Place of Delivery</span>
                        <select
                          value={pregnancyRows[i].place_of_delivery}
                          onChange={(e) =>
                            updatePregnancyRow(
                              i,
                              "place_of_delivery",
                              e.target.value,
                            )
                          }
                          style={{
                            ...fieldBase,
                            fontSize: "11px",
                            height: "28px",
                            cursor: "pointer",
                          }}
                        >
                          <option value=""></option>
                          <option>Hospital</option>
                          <option>Home</option>
                          <option>Other</option>
                        </select>
                      </Box>
                      <Box>
                        <span style={labelStyle}>Preterm Labor</span>
                        <select
                          value={pregnancyRows[i].preterm_labor}
                          onChange={(e) =>
                            updatePregnancyRow(
                              i,
                              "preterm_labor",
                              e.target.value,
                            )
                          }
                          style={{
                            ...fieldBase,
                            fontSize: "11px",
                            height: "28px",
                            cursor: "pointer",
                          }}
                        >
                          <option value=""></option>
                          <option>Yes</option>
                          <option>No</option>
                        </select>
                      </Box>
                      <Box>
                        <span style={labelStyle}>Outcome</span>
                        <select
                          value={pregnancyRows[i].outcome}
                          onChange={(e) =>
                            updatePregnancyRow(i, "outcome", e.target.value)
                          }
                          style={{
                            ...fieldBase,
                            fontSize: "11px",
                            height: "28px",
                            cursor: "pointer",
                          }}
                        >
                          <option value=""></option>
                          <option>Successful</option>
                          <option>IUFD</option>
                          <option>Living</option>
                          <option>Still Birth</option>
                          <option>Deceased</option>
                          <option>FTND</option>
                          <option>PTND</option>
                          <option>LSCS</option>
                          <option>MTP</option>
                          <option>Abortion</option>
                        </select>
                      </Box>
                      <Box>
                        <span style={labelStyle}>Comments</span>
                        <textarea
                          value={pregnancyRows[i].comments}
                          onChange={(e) =>
                            updatePregnancyRow(i, "comments", e.target.value)
                          }
                          style={{
                            ...fieldBase,
                            height: "28px",
                            resize: "none",
                            fontSize: "11px",
                            padding: "4px 6px",
                            lineHeight: "1.2",
                          }}
                        />
                      </Box>
                    </Box>
                  </Box>
                ))}

                {/* Buttons */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 1,
                    mt: 2,
                    flexWrap: "wrap",
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      ...primaryBtnTeal,
                      gap: 0.6,
                      fontSize: "13px",
                      p: 1.2,
                    }}
                    onClick={savePastPregnancies}
                  >
                    <SaveIcon sx={{ width: 15, height: 15 }} /> Save
                  </Button>
                  {/* <Button
                variant="contained"
                sx={{ ...primaryBtnTeal, gap: 0.6, fontSize: "13px", p: 1.2 }}
                onClick={savePastPregnancies}
              >
                <SaveIcon sx={{ width: 15, height: 15 }} />
                <ArrowForwardIcon sx={{ width: 14, height: 14 }} />
                Save & Continue
              </Button> */}
                  {/* <Button
                variant="contained"
                sx={{
                  ...primaryBtnTeal,
                  gap: 0.6,
                  fontSize: "13px",
                  p: 1.2,
                  backgroundColor: "neutral.grey",
                  border: "2px solid #90A4AE",
                  "&:hover": {
                    backgroundColor: "#546E7A",
                    border: "2px solid #546E7A",
                  },
                }}
              >
                Continue <ArrowForwardIcon sx={{ width: 15, height: 15 }} />
              </Button> */}
                </Box>
              </AccordionDetails>
            </Accordion>

            {/* Family History Accordion */}
            <Accordion
              expanded={expandedFamilyHistory}
              onChange={(e, isExpanded) => setExpandedFamilyHistory(isExpanded)}
              sx={{
                width: "100%",
                mt: 2,
                borderRadius: "10px",
                boxShadow: "none",
                border: "1px solid #E1E1E1",
                overflow: "hidden",
                "&:before": { display: "none" },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  backgroundColor: "neutral.white",
                  minHeight: "52px",
                  "& .MuiAccordionSummary-content": {
                    alignItems: "center",
                    margin: "12px 0",
                  },
                  "& .MuiAccordionSummary-expandIconWrapper": {
                    alignSelf: "center",
                  },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      backgroundColor: "neutral.blackBorder",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <HistoryOutlinedIcon sx={{ color: "#0097B2" }} />
                  </Box>
                  <Typography fontWeight={600}>Family History</Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails sx={{ p: 2 }}>
                {/* Top bar: No Family History + More/Less */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Checkbox
                      checked={noFamilyIllness}
                      onChange={(e) => setNoFamilyIllness(e.target.checked)}
                      size="small"
                      sx={{
                        p: 0,
                        color: "#0097B2",
                        "&.Mui-checked": { color: "#0097B2" },
                      }}
                    />
                    <Typography
                      sx={{ fontSize: "12px", fontWeight: 600, color: "#333" }}
                    >
                      No Family History Illness
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    {familyExtraCols.length > 0 && (
                      <Box
                        onClick={removeFamilyCol}
                        sx={{
                          fontSize: "11px",
                          fontWeight: 600,
                          color: "#E53935",
                          cursor: "pointer",
                          textDecoration: "underline",
                          userSelect: "none",
                        }}
                      >
                        Less
                      </Box>
                    )}
                    {familyExtraCols.length < 2 && (
                      <Box
                        onClick={addFamilyCol}
                        sx={{
                          fontSize: "11px",
                          fontWeight: 600,
                          color: "#0097B2",
                          cursor: "pointer",
                          textDecoration: "underline",
                          userSelect: "none",
                        }}
                      >
                        More
                      </Box>
                    )}
                  </Box>
                </Box>

                {/* Table */}
                <Box
                  sx={{
                    opacity: noFamilyIllness ? 0.4 : 1,
                    pointerEvents: noFamilyIllness ? "none" : "auto",
                  }}
                >
                  <TableContainer
                    sx={{
                      border: "1px solid #E1E1E1",
                      borderRadius: "8px",
                      mb: 2,
                      overflowX: "auto",
                    }}
                  >
                    <Table
                      size="small"
                      sx={{
                        tableLayout: "fixed",
                        minWidth: `${160 + (2 + 2 + familyExtraCols.length) * 100}px`,
                      }}
                    >
                      <colgroup>
                        <col style={{ width: "160px" }} />
                        {Array.from({
                          length: 2 + 2 + familyExtraCols.length,
                        }).map((_, i) => (
                          <col key={i} style={{ width: "100px" }} />
                        ))}
                      </colgroup>
                      <TableHead>
                        <TableRow sx={{ backgroundColor: "#F5F7F8" }}>
                          <TableCell
                            sx={{
                              fontSize: "10px",
                              fontWeight: 700,
                              color: "#666",
                              textTransform: "uppercase",
                              py: "7px",
                              borderRight: "1px solid #E1E1E1",
                              whiteSpace: "nowrap",
                              position: "sticky",
                              left: 0,
                              backgroundColor: "#F5F7F8",
                              zIndex: 2,
                            }}
                          />
                          {/* Fixed: Father, Mother */}
                          {familyStaticCols.map((col) => (
                            <TableCell
                              key={col.key}
                              sx={{
                                fontSize: "10px",
                                fontWeight: 700,
                                color: "#444",
                                textTransform: "uppercase",
                                py: "7px",
                                textAlign: "center",
                                borderRight: "1px solid #E1E1E1",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {col.label}
                            </TableCell>
                          ))}
                          {/* 2 default select cols */}
                          {familyDefaultSelectCols.map((col, i) => {
                            const isLast =
                              familyExtraCols.length === 0 &&
                              i === familyDefaultSelectCols.length - 1;
                            return (
                              <TableCell
                                key={`def-${i}`}
                                sx={{
                                  py: "4px",
                                  borderRight: isLast
                                    ? "none"
                                    : "1px solid #E1E1E1",
                                  textAlign: "center",
                                }}
                              >
                                <select
                                  value={col.relation}
                                  onChange={(e) =>
                                    updateDefaultSelectCol(
                                      i,
                                      "relation",
                                      e.target.value,
                                    )
                                  }
                                  style={{
                                    ...fieldBase,
                                    fontSize: "10px",
                                    height: "26px",
                                    cursor: "pointer",
                                    width: "92px",
                                  }}
                                >
                                  <option value="">Select</option>
                                  {FAMILY_RELATION_OPTIONS.map((r) => (
                                    <option key={r} value={r}>
                                      {r}
                                    </option>
                                  ))}
                                </select>
                              </TableCell>
                            );
                          })}
                          {/* Extra cols added via More */}
                          {familyExtraCols.map((col, i) => (
                            <TableCell
                              key={`extra-${i}`}
                              sx={{
                                py: "4px",
                                borderRight:
                                  i < familyExtraCols.length - 1
                                    ? "1px solid #E1E1E1"
                                    : "none",
                                textAlign: "center",
                              }}
                            >
                              <select
                                value={col.relation}
                                onChange={(e) =>
                                  updateExtraCol(i, "relation", e.target.value)
                                }
                                style={{
                                  ...fieldBase,
                                  fontSize: "10px",
                                  height: "26px",
                                  cursor: "pointer",
                                  width: "92px",
                                }}
                              >
                                <option value="">Select</option>
                                {FAMILY_RELATION_OPTIONS.map((r) => (
                                  <option key={r} value={r}>
                                    {r}
                                  </option>
                                ))}
                              </select>
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {/* helper: is this data-cell the last column overall? */}
                        {(() => {
                          const stickyLabelSx = (bg = "white") => ({
                            fontSize: "11px",
                            fontWeight: 600,
                            color: "#555",
                            py: "5px",
                            borderRight: "1px solid #E1E1E1",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            position: "sticky",
                            left: 0,
                            backgroundColor: bg,
                            zIndex: 1,
                          });
                          const isLastCell = (type, i) => {
                            if (familyExtraCols.length > 0)
                              return (
                                type === "extra" &&
                                i === familyExtraCols.length - 1
                              );
                            return (
                              type === "def" &&
                              i === familyDefaultSelectCols.length - 1
                            );
                          };
                          const cellBorder = (type, i) =>
                            isLastCell(type, i) ? "none" : "1px solid #E1E1E1";
                          const inputSx = {
                            ...fieldBase,
                            fontSize: "11px",
                            height: "26px",
                            width: "100%",
                          };
                          const selectSx = {
                            ...fieldBase,
                            fontSize: "11px",
                            height: "26px",
                            cursor: "pointer",
                            width: "100%",
                          };
                          return (
                            <>
                              {/* Age row */}
                              <TableRow sx={{ backgroundColor: "#FAFAFA" }}>
                                <TableCell sx={stickyLabelSx("#FAFAFA")}>
                                  Age
                                </TableCell>
                                {familyStaticCols.map((col) => (
                                  <TableCell
                                    key={col.key}
                                    sx={{
                                      p: "4px",
                                      borderRight: "1px solid #E1E1E1",
                                    }}
                                  >
                                    <input
                                      style={inputSx}
                                      value={familyStaticData[col.key].age}
                                      onChange={(e) =>
                                        updateStaticCol(
                                          col.key,
                                          "age",
                                          e.target.value,
                                        )
                                      }
                                    />
                                  </TableCell>
                                ))}
                                {familyDefaultSelectCols.map((col, i) => (
                                  <TableCell
                                    key={`def-age-${i}`}
                                    sx={{
                                      p: "4px",
                                      borderRight: cellBorder("def", i),
                                    }}
                                  >
                                    <input
                                      style={inputSx}
                                      value={col.age}
                                      onChange={(e) =>
                                        updateDefaultSelectCol(
                                          i,
                                          "age",
                                          e.target.value,
                                        )
                                      }
                                    />
                                  </TableCell>
                                ))}
                                {familyExtraCols.map((col, i) => (
                                  <TableCell
                                    key={i}
                                    sx={{
                                      p: "4px",
                                      borderRight: cellBorder("extra", i),
                                    }}
                                  >
                                    <input
                                      style={inputSx}
                                      value={col.age}
                                      onChange={(e) =>
                                        updateExtraCol(i, "age", e.target.value)
                                      }
                                    />
                                  </TableCell>
                                ))}
                              </TableRow>

                              {/* Living Status row */}
                              <TableRow>
                                <TableCell sx={stickyLabelSx("white")}>
                                  Living Status
                                </TableCell>
                                {familyStaticCols.map((col) => (
                                  <TableCell
                                    key={col.key}
                                    sx={{
                                      p: "4px",
                                      borderRight: "1px solid #E1E1E1",
                                    }}
                                  >
                                    <select
                                      style={selectSx}
                                      value={
                                        familyStaticData[col.key].livingStatus
                                      }
                                      onChange={(e) =>
                                        updateStaticCol(
                                          col.key,
                                          "livingStatus",
                                          e.target.value,
                                        )
                                      }
                                    >
                                      <option value=""></option>
                                      <option>Living</option>
                                      <option>Deceased</option>
                                      <option>Unknown</option>
                                    </select>
                                  </TableCell>
                                ))}
                                {familyDefaultSelectCols.map((col, i) => (
                                  <TableCell
                                    key={`def-ls-${i}`}
                                    sx={{
                                      p: "4px",
                                      borderRight: cellBorder("def", i),
                                    }}
                                  >
                                    <select
                                      style={selectSx}
                                      value={col.livingStatus}
                                      onChange={(e) =>
                                        updateDefaultSelectCol(
                                          i,
                                          "livingStatus",
                                          e.target.value,
                                        )
                                      }
                                    >
                                      <option value=""></option>
                                      <option>Living</option>
                                      <option>Deceased</option>
                                      <option>Unknown</option>
                                    </select>
                                  </TableCell>
                                ))}
                                {familyExtraCols.map((col, i) => (
                                  <TableCell
                                    key={i}
                                    sx={{
                                      p: "4px",
                                      borderRight: cellBorder("extra", i),
                                    }}
                                  >
                                    <select
                                      style={selectSx}
                                      value={col.livingStatus}
                                      onChange={(e) =>
                                        updateExtraCol(
                                          i,
                                          "livingStatus",
                                          e.target.value,
                                        )
                                      }
                                    >
                                      <option value=""></option>
                                      <option>Living</option>
                                      <option>Deceased</option>
                                      <option>Unknown</option>
                                    </select>
                                  </TableCell>
                                ))}
                              </TableRow>

                              {/* Disease rows */}
                              {FAMILY_DISEASES.map((disease, di) => (
                                <TableRow
                                  key={disease}
                                  sx={{
                                    backgroundColor:
                                      di % 2 === 0 ? "#FAFAFA" : "white",
                                  }}
                                >
                                  <TableCell
                                    sx={{
                                      ...stickyLabelSx(
                                        di % 2 === 0 ? "#FAFAFA" : "white",
                                      ),
                                      fontSize: "11px",
                                      fontWeight: 400,
                                      color: "#444",
                                    }}
                                  >
                                    {disease}
                                  </TableCell>
                                  {familyStaticCols.map((col) => (
                                    <TableCell
                                      key={col.key}
                                      sx={{
                                        p: "4px",
                                        textAlign: "center",
                                        borderRight: "1px solid #E1E1E1",
                                      }}
                                    >
                                      <Checkbox
                                        checked={
                                          !!familyStaticData[col.key].checked[
                                            disease
                                          ]
                                        }
                                        onChange={() =>
                                          toggleStaticDisease(col.key, disease)
                                        }
                                        size="small"
                                        sx={{
                                          p: 0,
                                          color: "#0097B2",
                                          "&.Mui-checked": { color: "#0097B2" },
                                        }}
                                      />
                                    </TableCell>
                                  ))}
                                  {familyDefaultSelectCols.map((col, i) => (
                                    <TableCell
                                      key={`def-d-${i}`}
                                      sx={{
                                        p: "4px",
                                        textAlign: "center",
                                        borderRight: cellBorder("def", i),
                                      }}
                                    >
                                      <Checkbox
                                        checked={!!col.checked[disease]}
                                        onChange={() =>
                                          toggleDefaultSelectDisease(i, disease)
                                        }
                                        size="small"
                                        sx={{
                                          p: 0,
                                          color: "#0097B2",
                                          "&.Mui-checked": { color: "#0097B2" },
                                        }}
                                      />
                                    </TableCell>
                                  ))}
                                  {familyExtraCols.map((col, i) => (
                                    <TableCell
                                      key={i}
                                      sx={{
                                        p: "4px",
                                        textAlign:
                                          disease === "Malignancy"
                                            ? "left"
                                            : "center",
                                        borderRight: cellBorder("extra", i),
                                      }}
                                    >
                                      {disease === "Malignancy" ? (
                                        <input
                                          style={inputSx}
                                          value={col.extraInputs[disease] || ""}
                                          onChange={(e) =>
                                            updateExtraColDiseaseInput(
                                              i,
                                              disease,
                                              e.target.value,
                                            )
                                          }
                                        />
                                      ) : (
                                        <Checkbox
                                          checked={!!col.checked[disease]}
                                          onChange={() =>
                                            toggleExtraDisease(i, disease)
                                          }
                                          size="small"
                                          sx={{
                                            p: 0,
                                            color: "#0097B2",
                                            "&.Mui-checked": {
                                              color: "#0097B2",
                                            },
                                          }}
                                        />
                                      )}
                                    </TableCell>
                                  ))}
                                </TableRow>
                              ))}
                            </>
                          );
                        })()}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {/* Comments */}
                  <Box sx={{ mb: 2 }}>
                    <label style={labelStyle}>Comments</label>
                    <textarea
                      rows={3}
                      value={familyComments}
                      onChange={(e) => setFamilyComments(e.target.value)}
                      style={{
                        ...fieldBase,
                        height: "auto",
                        resize: "vertical",
                        padding: "6px",
                        fontSize: "11px",
                      }}
                      placeholder="Add comments..."
                    />
                  </Box>
                </Box>

                {/* Buttons */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 1,
                    mt: 1,
                    flexWrap: "wrap",
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      ...primaryBtnTeal,
                      gap: 0.6,
                      fontSize: "13px",
                      p: 1.2,
                    }}
                    onClick={saveFamilyHistory}
                  >
                    <SaveIcon sx={{ width: 15, height: 15 }} /> Save
                  </Button>
                  {/* <Button
                variant="contained"
                sx={{ ...primaryBtnTeal, gap: 0.6, fontSize: "13px", p: 1.2 }}
                onClick={saveFamilyHistory}
              >
                <SaveIcon sx={{ width: 15, height: 15 }} />
                <ArrowForwardIcon sx={{ width: 14, height: 14 }} />
                Save & Continue
              </Button> */}
                  {/* <Button
                variant="contained"
                sx={{
                  ...primaryBtnTeal,
                  gap: 0.6,
                  fontSize: "13px",
                  p: 1.2,
                  backgroundColor: "neutral.grey",
                  border: "2px solid #90A4AE",
                  "&:hover": {
                    backgroundColor: "#546E7A",
                    border: "2px solid #546E7A",
                  },
                }}
              >
                Continue <ArrowForwardIcon sx={{ width: 15, height: 15 }} />
              </Button> */}
                </Box>
              </AccordionDetails>
            </Accordion>

            {/* Social History Accordion */}
            <Accordion
              expanded={expandedSocialHistory}
              onChange={(e, isExpanded) => setExpandedSocialHistory(isExpanded)}
              sx={{
                width: "100%",
                mt: 2,
                borderRadius: "10px",
                boxShadow: "none",
                border: "1px solid #E1E1E1",
                overflow: "hidden",
                "&:before": { display: "none" },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  backgroundColor: "neutral.white",
                  minHeight: "52px",
                  "& .MuiAccordionSummary-content": {
                    alignItems: "center",
                    margin: "12px 0",
                  },
                  "& .MuiAccordionSummary-expandIconWrapper": {
                    alignSelf: "center",
                  },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      backgroundColor: "neutral.blackBorder",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <HistoryOutlinedIcon sx={{ color: "#0097B2" }} />
                  </Box>
                  <Typography fontWeight={600}>Social History</Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails sx={{ p: 2 }}>
                {/* Row 1: Marital Status | Education */}
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: 1.5,
                    mb: 1.5,
                  }}
                >
                  <Box>
                    <label style={labelStyle}>Marital Status</label>
                    <select
                      style={{ ...fieldBase, cursor: "pointer" }}
                      value={socialMaritalStatus}
                      onChange={(e) => setSocialMaritalStatus(e.target.value)}
                    >
                      <option value="">Select</option>
                      {[
                        "Single",
                        "Married",
                        "UnMarried",
                        "Divorced",
                        "Widowed",
                        "Separated",
                        "Patner",
                      ].map((o) => (
                        <option key={o}>{o}</option>
                      ))}
                    </select>
                  </Box>
                  <Box>
                    <label style={labelStyle}>Education</label>
                    <select
                      style={{ ...fieldBase, cursor: "pointer" }}
                      value={socialEducation}
                      onChange={(e) => setSocialEducation(e.target.value)}
                    >
                      <option value="">Select</option>
                      {[
                        "No Formal Education",
                        "Primary",
                        "Secondary",
                        "Diploma",
                        "Post Diploma",
                        "Graduate",
                        "Post Graduate",
                        "Doctorate",
                        "Research",
                      ].map((o) => (
                        <option key={o}>{o}</option>
                      ))}
                    </select>
                  </Box>
                </Box>

                {/* Row 2: Occupation | Industry */}
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: 1.5,
                    mb: 1.5,
                  }}
                >
                  <Box>
                    <label style={labelStyle}>Occupation</label>
                    <input
                      style={fieldBase}
                      value={socialOccupation}
                      onChange={(e) => setSocialOccupation(e.target.value)}
                      placeholder="Enter occupation"
                    />
                  </Box>
                  <Box>
                    <label style={labelStyle}>Industry</label>
                    <select
                      style={{ ...fieldBase, cursor: "pointer" }}
                      value={socialIndustry}
                      onChange={(e) => setSocialIndustry(e.target.value)}
                    >
                      <option value=""></option>
                      <option>Education</option>
                      <option>Medical</option>
                      <option>Electrical</option>
                      <option>Electronics</option>
                      <option>Information and Technology</option>
                      <option>Manufacturing Industry</option>
                      <option>Banking</option>
                      <option>Media and Entertainment</option>
                      <option>Food industries</option>
                      <option>Transport</option>
                      <option>Agriculture</option>
                      <option>Science and Research</option>
                      <option>Support Services</option>
                    </select>
                  </Box>
                </Box>

                {/* Row 3: General Stress Level | Diet | Caffeine Intake */}
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr",
                    gap: 1.5,
                    mb: 1.5,
                  }}
                >
                  <Box>
                    <label style={labelStyle}>General Stress Level</label>
                    <select
                      style={{ ...fieldBase, cursor: "pointer" }}
                      value={socialStress}
                      onChange={(e) => setSocialStress(e.target.value)}
                    >
                      <option value="">Select</option>
                      {["Low", "Medium", "High", "Very High"].map((o) => (
                        <option key={o}>{o}</option>
                      ))}
                    </select>
                  </Box>
                  <Box>
                    <label style={labelStyle}>Diet</label>
                    <select
                      style={{ ...fieldBase, cursor: "pointer" }}
                      value={socialDiet}
                      onChange={(e) => setSocialDiet(e.target.value)}
                    >
                      <option value="">Select</option>
                      {[
                        "Regular",
                        "Vegetarian",
                        "Non-Vegetarian",
                        "1800 Calorie",
                        "Diebetic or Calorie controlled",
                        "No Added Salt",
                        "Vegan",
                        "Eggetarian",
                        "Mixed",
                        "Other",
                      ].map((o) => (
                        <option key={o}>{o}</option>
                      ))}
                    </select>
                  </Box>
                  <Box>
                    <label style={labelStyle}>Caffeine Intake</label>
                    <select
                      style={{ ...fieldBase, cursor: "pointer" }}
                      value={socialCaffeineIntake}
                      onChange={(e) => setSocialCaffeineIntake(e.target.value)}
                    >
                      <option value="">Select</option>
                      {[
                        "None",
                        "Occasional",
                        "Modrate",
                        "Heavy",
                        "1 cup/day",
                        "2-3 cups/day",
                        "4-5 cups/day",
                        "> 5 cups/day",
                      ].map((o) => (
                        <option key={o}>{o}</option>
                      ))}
                    </select>
                  </Box>
                </Box>

                {/* Divider label */}
                <Typography
                  sx={{
                    fontSize: "10px",
                    fontWeight: 700,
                    color: "#0097B2",
                    textTransform: "uppercase",
                    mb: 1,
                    letterSpacing: "0.5px",
                  }}
                >
                  Tobacco & Substance Use
                </Typography>

                {/* Tobacco Smoking row */}
                <Box
                  sx={{
                    border: "1px solid #E1E1E1",
                    borderRadius: "8px",
                    p: 1.2,
                    mb: 1.2,
                    backgroundColor: "#fafcfc",
                  }}
                >
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "1.2fr 1fr",
                      gap: 1.5,
                    }}
                  >
                    <Box>
                      <label style={labelStyle}>Tobacco — Smoking Status</label>
                      <select
                        style={{ ...fieldBase, cursor: "pointer" }}
                        value={socialTobaccoSmoking}
                        onChange={(e) =>
                          setSocialTobaccoSmoking(e.target.value)
                        }
                      >
                        <option value=""></option>
                        {[
                          "current every day smoker",
                          "current some day smoker",
                          "former smoker",
                          "never smoker",
                          "smoking, current status unknown",
                          "unknown if ever smoked",
                          "heavy tobacco smoker",
                          "light tobacco smoker",
                        ].map((o) => (
                          <option key={o}>{o}</option>
                        ))}
                      </select>
                    </Box>
                    <Box>
                      <label style={labelStyle}>Quantity</label>
                      <select
                        style={{ ...fieldBase, cursor: "pointer" }}
                        value={socialTobaccoSmokingQty}
                        onChange={(e) =>
                          setSocialTobaccoSmokingQty(e.target.value)
                        }
                      >
                        <option value="">Select</option>
                        {TOBACCO_SMOKING_QTY.map((o) => (
                          <option key={o}>{o}</option>
                        ))}
                      </select>
                    </Box>
                    <Box>
                      <label style={labelStyle}>Duration</label>
                      <input
                        style={fieldBase}
                        value={socialTobaccoSmokingDuration}
                        onChange={(e) =>
                          setSocialTobaccoSmokingDuration(e.target.value)
                        }
                        placeholder="e.g. 5 years"
                      />
                    </Box>
                  </Box>
                </Box>

                {/* Tobacco Chewing row */}
                <Box
                  sx={{
                    border: "1px solid #E1E1E1",
                    borderRadius: "8px",
                    p: 1.2,
                    mb: 1.2,
                    backgroundColor: "#fafcfc",
                  }}
                >
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "1.2fr 1fr",
                      gap: 1.5,
                    }}
                  >
                    <Box>
                      <label style={labelStyle}>Tobacco — Chewing Status</label>
                      <select
                        style={{ ...fieldBase, cursor: "pointer" }}
                        value={socialTobaccoChewing}
                        onChange={(e) =>
                          setSocialTobaccoChewing(e.target.value)
                        }
                      >
                        <option value="">Select</option>
                        {["Never", "Yes", "Former", "Quit"].map((o) => (
                          <option key={o}>{o}</option>
                        ))}
                      </select>
                    </Box>
                    <Box>
                      <label style={labelStyle}>Quantity</label>
                      <select
                        style={{ ...fieldBase, cursor: "pointer" }}
                        value={socialTobaccoChewingQty}
                        onChange={(e) =>
                          setSocialTobaccoChewingQty(e.target.value)
                        }
                      >
                        <option value="">Select</option>
                        {TOBACCO_CHEWING_QTY.map((o) => (
                          <option key={o}>{o}</option>
                        ))}
                      </select>
                    </Box>
                    <Box>
                      <label style={labelStyle}>Duration</label>
                      <input
                        style={fieldBase}
                        value={socialTobaccoChewingDuration}
                        onChange={(e) =>
                          setSocialTobaccoChewingDuration(e.target.value)
                        }
                        placeholder="e.g. 2 years"
                      />
                    </Box>
                  </Box>
                </Box>

                {/* Alcohol row */}
                <Box
                  sx={{
                    border: "1px solid #E1E1E1",
                    borderRadius: "8px",
                    p: 1.2,
                    mb: 1.2,
                    backgroundColor: "#fafcfc",
                  }}
                >
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "1.2fr 1fr 1fr",
                      gap: 1.5,
                    }}
                  >
                    <Box>
                      <label style={labelStyle}>Alcohol</label>
                      <select
                        style={{ ...fieldBase, cursor: "pointer" }}
                        value={socialAlcohol}
                        onChange={(e) => setSocialAlcohol(e.target.value)}
                      >
                        <option value="">Select</option>
                        {["No", "Yes", "Former", "Quit"].map((o) => (
                          <option key={o}>{o}</option>
                        ))}
                      </select>
                    </Box>
                    <Box
                      sx={{
                        opacity: socialAlcohol === "Yes" ? 1 : 0.4,
                        pointerEvents:
                          socialAlcohol === "Yes" ? "auto" : "none",
                      }}
                    >
                      <label style={labelStyle}>If Yes</label>
                      <select
                        style={{ ...fieldBase, cursor: "pointer" }}
                        value={socialAlcoholIfYes}
                        onChange={(e) => setSocialAlcoholIfYes(e.target.value)}
                      >
                        <option value="">Select</option>
                        {[
                          "Occasional",
                          "Social",
                          "Weekly",
                          "Daily",
                          "Heavy",
                        ].map((o) => (
                          <option key={o}>{o}</option>
                        ))}
                      </select>
                    </Box>
                    <Box>
                      <label style={labelStyle}>Duration</label>
                      <input
                        style={fieldBase}
                        value={socialAlcoholDuration}
                        onChange={(e) =>
                          setSocialAlcoholDuration(e.target.value)
                        }
                        placeholder="e.g. 3 years"
                      />
                    </Box>
                  </Box>
                </Box>

                {/* Drugs row */}
                <Box
                  sx={{
                    border: "1px solid #E1E1E1",
                    borderRadius: "8px",
                    p: 1.2,
                    mb: 1.5,
                    backgroundColor: "#fafcfc",
                  }}
                >
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "1.2fr 1fr 1fr",
                      gap: 1.5,
                    }}
                  >
                    <Box>
                      <label style={labelStyle}>Drugs</label>
                      <select
                        style={{ ...fieldBase, cursor: "pointer" }}
                        value={socialDrugs}
                        onChange={(e) => setSocialDrugs(e.target.value)}
                      >
                        <option value="">Select</option>
                        {["No", "Yes", "Former", "Quit"].map((o) => (
                          <option key={o}>{o}</option>
                        ))}
                      </select>
                    </Box>
                    <Box
                      sx={{
                        opacity: socialDrugs === "Yes" ? 1 : 0.4,
                        pointerEvents: socialDrugs === "Yes" ? "auto" : "none",
                      }}
                    >
                      <label style={labelStyle}>If Yes (select all)</label>
                      <Box
                        sx={{
                          border: "1px solid #D0D8DA",
                          borderRadius: "6px",
                          backgroundColor: "white",
                          maxHeight: "80px",
                          overflowY: "auto",
                          p: "4px 6px",
                        }}
                      >
                        {DRUG_OPTIONS.map((drug) => (
                          <Box
                            key={drug}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 0.5,
                            }}
                          >
                            <Checkbox
                              checked={socialDrugsSelected.includes(drug)}
                              onChange={() =>
                                setSocialDrugsSelected((p) =>
                                  p.includes(drug)
                                    ? p.filter((d) => d !== drug)
                                    : [...p, drug],
                                )
                              }
                              size="small"
                              sx={{
                                p: 0,
                                color: "#0097B2",
                                "&.Mui-checked": { color: "#0097B2" },
                              }}
                            />
                            <Typography
                              sx={{ fontSize: "11px", color: "#333" }}
                            >
                              {drug}
                            </Typography>
                          </Box>
                        ))}
                      </Box>
                    </Box>
                    <Box>
                      <label style={labelStyle}>Duration</label>
                      <input
                        style={fieldBase}
                        value={socialDrugsDuration}
                        onChange={(e) => setSocialDrugsDuration(e.target.value)}
                        placeholder="e.g. 1 year"
                      />
                    </Box>
                  </Box>
                </Box>

                {/* Exercise */}
                <Box sx={{ mb: 1.5 }}>
                  <label style={labelStyle}>Exercise</label>
                  <textarea
                    value={socialExercise}
                    onChange={(e) => setSocialExercise(e.target.value)}
                    maxLength={200}
                    placeholder="Describe exercise routine..."
                    style={{
                      ...fieldBase,
                      height: "50px",
                      resize: "none",
                      padding: "6px",
                      fontSize: "11px",
                    }}
                  />
                  <Box
                    sx={{
                      textAlign: "right",
                      fontSize: "10px",
                      color: "#999",
                      mt: "2px",
                    }}
                  >
                    {socialExercise.length}/200
                  </Box>
                </Box>

                {/* Comments */}
                <Box sx={{ mb: 2 }}>
                  <label style={labelStyle}>Comments</label>
                  <textarea
                    value={socialComments}
                    onChange={(e) => setSocialComments(e.target.value)}
                    placeholder="Add comments..."
                    style={{
                      ...fieldBase,
                      height: "50px",
                      resize: "none",
                      padding: "6px",
                      fontSize: "11px",
                    }}
                  />
                </Box>

                {/* Buttons */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 1,
                    mt: 1,
                    flexWrap: "wrap",
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      ...primaryBtnTeal,
                      gap: 0.6,
                      fontSize: "13px",
                      p: 1.2,
                    }}
                    onClick={saveSocialHistory}
                  >
                    <SaveIcon sx={{ width: 15, height: 15 }} /> Save
                  </Button>
                  {/* <Button
                variant="contained"
                sx={{ ...primaryBtnTeal, gap: 0.6, fontSize: "13px", p: 1.2 }}
                onClick={saveSocialHistory}
              >
                <SaveIcon sx={{ width: 15, height: 15 }} />
                <ArrowForwardIcon sx={{ width: 14, height: 14 }} />
                Save & Continue
              </Button> */}
                  {/* <Button
                variant="contained"
                sx={{
                  ...primaryBtnTeal,
                  gap: 0.6,
                  fontSize: "13px",
                  p: 1.2,
                  backgroundColor: "neutral.grey",
                  border: "2px solid #90A4AE",
                  "&:hover": {
                    backgroundColor: "#546E7A",
                    border: "2px solid #546E7A",
                  },
                }}
              >
                Continue <ArrowForwardIcon sx={{ width: 15, height: 15 }} />
              </Button> */}
                </Box>
              </AccordionDetails>
            </Accordion>
          </>
        )}
      </Grid>

      <Dialog
        open={duplicateDialog.open}
        onClose={() => setDuplicateDialog({ open: false, duplicates: [], dedupedArr: [] })}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ color: "#d32f2f", fontWeight: 600 }}>
          Duplicate Reports Found
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 1 }}>
            The following duplicate tests will be deleted before saving:
          </Typography>
          <List dense>
            {duplicateDialog.duplicates.map((r, i) => (
              <ListItem key={i} sx={{ py: 0.5 }}>
                <ListItemText
                  primary={r.name || `Test ID: ${r.id}`}
                  secondary={r.value ? `Value: ${r.value}` : null}
                  primaryTypographyProps={{ fontSize: 13 }}
                  secondaryTypographyProps={{ fontSize: 12 }}
                />
              </ListItem>
            ))}
          </List>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={() => setDuplicateDialog({ open: false, duplicates: [], dedupedArr: [] })}
            sx={{ color: "#555" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleDeleteDuplicatesAndProceed}
            sx={{ backgroundColor: "#d32f2f", "&:hover": { backgroundColor: "#b71c1c" } }}
          >
            Delete & Proceed
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PatientReport;

// old section  don't delete this comment
// import React, { useEffect, useState } from "react";
// import { Box, Grid, TextField, Button, Typography } from "@mui/material";
// import { primaryBtn, textfieldText } from "../../style/AppointmentStyle";
// import { useSelector } from "react-redux";
// import { updateMedicalTest } from "../../connections/postApi";
// import { showToast } from "../../utils/toastUtil";

// const PatientReport = () => {
//   const appointmentData  = useSelector((state)=> state.nurse.appointmentData);
//   const patientDetailsData  = useSelector((state)=> state.nurse.patientDetailsData);
//   const isLoading  = useSelector((state)=> state.nurse.isLoading);

//   useEffect(()=>{
//     setFormState(appointmentData?.quick_investigations)
//   },[appointmentData])

//   const[formState,setFormState]=useState(appointmentData?.quick_investigations ||[]);
//   // console.log(formState);

//   const handleInputChange = (index, value) => {
//     const updatedFormState = formState.map((investigation, i) =>
//       i === index ? { ...investigation, value } : investigation
//     );
//     setFormState(updatedFormState);
//   };

//   const saveReport= async()=>{
//     const reports = formState.reduce((acc, investigation) => {
//       acc[investigation.name] = investigation.value || "";
//       return acc;
//     }, {});

//     const data ={
//         reports,
//         patient_id:  patientDetailsData.id,
//         appointment_id : appointmentData.id,
//         state: "green",
//     }
//   let result = await updateMedicalTest(data);
//   console.log(result);
//   showToast('patient report update ' , 'SUCCESS');
//   }

//   return (
//     <Grid container sm={12} md={5.4} marginBottom={"auto"} lg={3.8}>
//       <Grid
//         item
//         sx={{ border: "1px solid rgba(0, 0, 0, 0.125)", padding: "15px" }}
//       >

//         <Grid container spacing={2}>
//          {formState?.length>1 && formState?.map((investigation , index)=>
//           <Grid item xs={6} sm={3} key={index}>
//           <Typography variant="body1_text_bold">{investigation.name}</Typography>
//           <TextField
//             sx={textfieldText}
//             fullWidth
//             placeholder={investigation.name}
//             value={investigation.value}
//             onChange={(e) => handleInputChange(index, e.target.value)}
//             variant="outlined"
//           />
//           </Grid>
//            )}
//      </Grid>

//        {formState?.length>1 &&  <Box sm={12} lg={12} sx={{width :'100%'}}>
//           <Button variant="contained" xs={12} sm={12} sx={{...primaryBtn , width:'100%'}}  onClick={saveReport}  disabled={isLoading}>
//             <Typography variant="small_Text" >Save</Typography>
//           </Button>
//        </Box>
//          }

//       </Grid>
//     </Grid>

//   );
// };

// export default PatientReport;
